
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

parcelRegister("bpoON", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsQuery", () => $17d466086b1d89f6$export$7df92c2c6d389da3);

var $d2LG0 = parcelRequire("d2LG0");
const $17d466086b1d89f6$export$7df92c2c6d389da3 = (0, $d2LG0.default)`query BreadcrumbsQuery($spaceKey:String!$contentId:ID$skipContent:Boolean!){spaces(spaceKey:$spaceKey first:10){nodes{alias id name homepage{id}}}content(id:$contentId status:["current" "draft" "archived"])@skip(if:$skipContent){nodes{id type subType status title ancestors{id type subType title status}}}}`;

});

parcelRegister("azYNm", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsLoader", () => $4048f2d5e9ff9162$export$74cf87e24679ef23);
$parcel$export(module.exports, "Breadcrumbs", () => $4048f2d5e9ff9162$export$2dc68d50d56fbbd);
$parcel$export(module.exports, "BreadcrumbsNonLoadable", () => $4048f2d5e9ff9162$export$8bb26699ba16d6a3);
$parcel$export(module.exports, "FixedBreadcrumbsNavForPageLayoutLoader", () => $4048f2d5e9ff9162$export$f979c33d59431f8e);
$parcel$export(module.exports, "FixedSpaceHeaderContainer", () => (parcelRequire("8MMdp")).FixedSpaceHeaderContainer);
$parcel$export(module.exports, "FixedSpaceHeaderWithBannerContainer", () => (parcelRequire("8MMdp")).FixedSpaceHeaderWithBannerContainer);
$parcel$export(module.exports, "BREADCRUMB_HEADER_HEIGHT", () => (parcelRequire("8MMdp")).BREADCRUMB_HEADER_HEIGHT);
$parcel$export(module.exports, "BREADCRUMBS_MODES", () => (parcelRequire("5Vf1r")).BREADCRUMBS_MODES);
$parcel$export(module.exports, "buildContentPath", () => (parcelRequire("hzkzq")).buildContentPath);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $eCJDV = parcelRequire("eCJDV");

var $8MMdp = parcelRequire("8MMdp");

var $5Vf1r = parcelRequire("5Vf1r");

var $hzkzq = parcelRequire("hzkzq");

const $4048f2d5e9ff9162$export$74cf87e24679ef23 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b4n75",
    name: "BreadcrumbsLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).Breadcrumbs,
    loading: (0, $eCJDV.BreadcrumbsPlaceholder)
});
const $4048f2d5e9ff9162$export$2dc68d50d56fbbd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4048f2d5e9ff9162$export$74cf87e24679ef23, props);
const $4048f2d5e9ff9162$export$8bb26699ba16d6a3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8MMdp.Breadcrumbs), props);

const $4048f2d5e9ff9162$export$f979c33d59431f8e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "r9MLy",
    name: "FixedBreadcrumbsNavForPageLayoutLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).FixedBreadcrumbsNavForPageLayout
});

});
parcelRegister("eCJDV", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsPlaceholder", () => $0c4308f795e44815$export$98d1f051069dd73b);

var $gwFzn = parcelRequire("gwFzn");

var $fwDOR = parcelRequire("fwDOR");
function $0c4308f795e44815$export$98d1f051069dd73b() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fwDOR.default), {
        name: "BreadcrumbsPlaceholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "breadcrumbs-placeholder",
        "data-vc": "breadcrumbs-placeholder"
    }));
}

});

parcelRegister("8MMdp", function(module, exports) {

$parcel$export(module.exports, "BREADCRUMB_HEADER_HEIGHT", () => $6d14bad88596319b$export$947cbc4fd63441e3);
$parcel$export(module.exports, "FixedSpaceHeaderContainer", () => $6d14bad88596319b$export$ba9528a5a0141231);
$parcel$export(module.exports, "Breadcrumbs", () => $6d14bad88596319b$export$2dc68d50d56fbbd);
$parcel$export(module.exports, "FixedBreadcrumbsNavForPageLayout", () => $6d14bad88596319b$export$7d2750c639212b06);
$parcel$export(module.exports, "FixedSpaceHeaderWithBannerContainer", () => $6d14bad88596319b$export$5adc3a1912461c1e);
/* Breadcrumbs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $fppBw = parcelRequire("fppBw");

var $j1Ss3 = parcelRequire("j1Ss3");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $dIouf = parcelRequire("dIouf");

var $1NBp8 = parcelRequire("1NBp8");

var $cb6fO = parcelRequire("cb6fO");
var $7zgzO = parcelRequire("7zgzO");

var $kDja4 = parcelRequire("kDja4");

var $ep3mz = parcelRequire("ep3mz");

var $cEgMD = parcelRequire("cEgMD");

var $3joiD = parcelRequire("3joiD");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $9wGTI = parcelRequire("9wGTI");

var $irVI7 = parcelRequire("irVI7");
var $ln0hx = parcelRequire("ln0hx");

var $gCX2C = parcelRequire("gCX2C");

var $bpoON = parcelRequire("bpoON");

var $eCJDV = parcelRequire("eCJDV");

var $hzkzq = parcelRequire("hzkzq");

var $i23fb = parcelRequire("i23fb");

var $5Vf1r = parcelRequire("5Vf1r");

const $6d14bad88596319b$var$CompanyHubBreadcrumbs = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rj-y7",
    name: "CompanyHubBreadcrumbs",
    loader: async ()=>(await (parcelRequire("lKXie"))).CompanyHubBreadcrumbs
});
const $6d14bad88596319b$export$947cbc4fd63441e3 = 58;
const $6d14bad88596319b$var$i18n = (0, $2nPZH.defineMessages)({
    archivedPagesBreadcrumbsTitle: {
        id: "breadcrumbs.archived-pages-list-link",
        defaultMessage: "Archived content"
    },
    archivedContentBreadcrumbsTitle: {
        id: "breadcrumbs.archived-content-list-link",
        defaultMessage: "Archived"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6d14bad88596319b$export$ba9528a5a0141231 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNav4Enabled: isNav4Enabled, isFullWidth: isFullWidth, isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, isModernizedBreadcrumbsEnabled: isModernizedBreadcrumbsEnabled, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ji2brd": (0, $iAWao.default)(__cmplp.justifyContent || 'space-between')
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_n7zlglyw _4t3i1oqx _1pby1ial _1bsb1osq _1e0c1txw _4cvr1h6o _vchhusvi _1bah1vxp",
            !__cmplp.isNav4Enabled && __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : __cmplp.isModernizedBreadcrumbsEnabled ? "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf" : "_ca0qidpf _u5f31f4h _n3tdidpf _19bv1f4h",
            __cmplp.isTransparent ? "_bfhk18uv" : "_bfhkvuon",
            !__cmplp.isNav4Enabled && __cmplp.isFullWidth ? "_1ltvidpf" : "_1ltv1d4h",
            __cmplp.className
        ])
    });
});
const $6d14bad88596319b$var$SpaceHeaderWithBannerWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_n7zlglyw _1pby1ial _1bsb1osq _1e0c1txw _2lx21bp4 _vchhusvi",
            __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isTransparent ? "_bfhk18uv" : "_bfhkvuon",
            __cmplp.isFullWidth ? "_1ltvidpf" : "_1ltv1d4h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $6d14bad88596319b$var$SpaceHeaderWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, isModernizedBreadcrumbsEnabled: isModernizedBreadcrumbsEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4t3i1oqx _1e0c1txw _4cvr1h6o",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : __cmplp.isModernizedBreadcrumbsEnabled ? "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf" : "_ca0qidpf _u5f31f4h _n3tdidpf _19bv1f4h",
            __cmplp.isModernizedBreadcrumbsEnabled ? "_zulpyh40" : "_zulpidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6d14bad88596319b$var$BreadcrumbWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "nav", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2hwxpxbi _1e0c1txw _4cvr1h6o _16jlidpf _1ul9idpf",
            __cmplp.compact ? "_1wyb1crf" : "_1wybdlk8",
            __cmplp.className
        ])
    });
});
$6d14bad88596319b$export$2dc68d50d56fbbd.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    /**
   * Show an extra breadcrumb item when it is provided.
   * This is used in sticky content header where we want to display the title of the current page.
   */ contentTitle: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    /**
   * Include the current content when true
   */ includeSelf: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    /**
   * For modernised breadcrumbs, if a content link value is provided, allow the content title portion to link to that
   * (used for views like page analytics and version history)
   */ contentLink: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string
};
function $6d14bad88596319b$export$2dc68d50d56fbbd({ compact: compact, contentId: contentId, contentTitle: contentTitle, spaceKey: spaceKey, includeSelf: includeSelf, testId: testId, showInlineRename: showInlineRename, shouldDisableMoveButton: shouldDisableMoveButton, displayMode: displayMode = (0, $5Vf1r.BREADCRUMBS_MODES).FULL, contentLink: contentLink, contentType: contentType, subType: subType }) {
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const intl = (0, $dBxQj.default)();
    if (!spaceKey) return null;
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$var$CompanyHubBreadcrumbs, null);
    const fireBreadcrumbError = (error)=>{
        let err;
        let nativeError;
        try {
            err = JSON.stringify(error, Object.getOwnPropertyNames(error)); // https://stackoverflow.com/a/26199752
            nativeError = JSON.stringify(error['nativeError']);
        } catch  {
            // if no error, means it failed to stringify so just set as empty string
            if (!err) err = '';
            if (!nativeError) nativeError = '';
        } finally{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'breadcrumbs',
                    action: 'errored',
                    actionSubject: 'viewPageBreadcrumbs',
                    attributes: {
                        message: error.message,
                        error: err,
                        nativeError: nativeError
                    }
                }
            }).fire();
        }
    };
    if ((0, $9wGTI.fg)('confluence_modernized_breadcrumbs')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.GenericErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO,
        onError: fireBreadcrumbError,
        renderOnError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Vf1r.BreadcrumbsWithSpaceNameDropdown), {
        contentTitle: contentTitle,
        spaceKey: spaceKey || '',
        contentId: contentId,
        testId: testId,
        showInlineRename: showInlineRename,
        shouldDisableMoveButton: shouldDisableMoveButton,
        displayMode: displayMode,
        contentLink: contentLink,
        contentType: contentType,
        subType: subType
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.GenericErrorBoundary), {
        attribution: (0, $dIouf.Attribution).DISCO,
        onError: fireBreadcrumbError,
        renderOnError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), (0, $3joiD.getQueryPropsAndSetFetchPolicyForNetworkOnlyQuery)({
        query: (0, $bpoON.BreadcrumbsQuery),
        context: {
            single: true
        },
        variables: {
            spaceKey: spaceKey,
            contentId: contentId,
            skipContent: !contentId
        } // No fetch policy here because we are relying on network-only preloader to get the latest data
    }), ({ data: data, error: error })=>{
        // Note don't check for loading as when refreshing data we will get data={...} and loading=true
        // In this case if we display the placeholder it will flash before the data is displayed
        // We should continue render with existing data and then update when the new data is available
        if (!data || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eCJDV.BreadcrumbsPlaceholder), null);
        const space = data?.spaces?.nodes?.[0];
        const content = data?.content?.nodes?.[0]; // we need both space data and content (if requested)
        if (!space) // @TODO fixme: should we really silently return null here?
        // If it's possible for us to get graphql data but not these
        // fields, something seems wrong
        return null;
        const spaceHomepageId = space?.homepage?.id;
        const spaceOverviewPath = (0, $hzkzq.buildContentPath)({
            contentType: 'page',
            isSpaceOverview: true,
            query: spaceHomepageId ? {
                [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
            } : undefined,
            spaceAlias: space.alias,
            spaceKey: spaceKey
        });
        const ancestors = content ? (0, $hzkzq.filterAncestors)(content, spaceHomepageId).map(({ id: id, title: title, type: type })=>({
                href: (0, $hzkzq.buildContentPath)({
                    contentId: id,
                    contentSlug: (0, $cb6fO.generateSlug)(title || undefined),
                    contentType: type,
                    isSpaceOverview: false,
                    spaceAlias: space.alias,
                    spaceKey: spaceKey
                }),
                id: id || '',
                title: title || '',
                contentType: type || undefined
            })) : [];
        if (content?.status === (0, $hzkzq.CONTENT_STATUS_ARCHIVED) || (0, $gCX2C.getSkipContentAndTypes)(match?.name).isArchivedPagesList) {
            const archivePagesListLink = {
                href: (0, $1NBp8.SPACE_ARCHIVED_PAGES).toUrl({
                    spaceKey: space.alias || spaceKey
                }),
                title: intl.formatMessage(isWhiteboardFeatureEnabled('whiteboardsEnabled') ? $6d14bad88596319b$var$i18n.archivedContentBreadcrumbsTitle : $6d14bad88596319b$var$i18n.archivedPagesBreadcrumbsTitle),
                id: 'archived_pages_list'
            };
            ancestors.unshift(archivePagesListLink);
        }
        if (includeSelf && content) {
            const { title: title, id: id, type: type } = content;
            if (title && id && type) {
                const self = {
                    href: (0, $hzkzq.buildContentPath)({
                        contentId: id,
                        contentSlug: (0, $cb6fO.generateSlug)(title),
                        contentType: type,
                        isSpaceOverview: false,
                        spaceAlias: space.alias,
                        spaceKey: spaceKey
                    }),
                    id: id,
                    title: title
                }; // add yourself as an ancestor in breadcrumbs
                ancestors.push(self);
            }
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$var$BreadcrumbWrapper, {
            compact: compact,
            "aria-label": "Breadcrumbs",
            "data-vc": "breadcrumbs-loader",
            ...ssrPlaceholderIdProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i23fb.BreadcrumbsPicker), {
            ancestors: ancestors,
            contentTitle: contentTitle || '',
            spaceName: space.name || space.alias || spaceKey,
            spaceOverviewPath: spaceOverviewPath,
            compact: compact
        }));
    })));
}
const $6d14bad88596319b$export$7d2750c639212b06 = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$export$ba9528a5a0141231, {
        isModernizedBreadcrumbsEnabled: (0, $9wGTI.fg)('confluence_modernized_breadcrumbs')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
        spaceKey: spaceKey
    }));
};
const $6d14bad88596319b$export$5adc3a1912461c1e = ({ children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
        isThemed: isThemed,
        isFullWidth: isFullWidth,
        isTransparent: isTransparent
    }, banner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
        isThemed: isThemed,
        "data-testid": testId,
        isModernizedBreadcrumbsEnabled: (0, $9wGTI.fg)('confluence_modernized_breadcrumbs'),
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_object_header'),
        shouldHavePadding: shouldHavePadding
    }, children));

});
parcelRegister("gCX2C", function(module, exports) {

$parcel$export(module.exports, "getSkipContentAndTypes", () => $80d9c508f014fb0a$export$dda18feb566b4c7a);

var $1NBp8 = parcelRequire("1NBp8");
const $80d9c508f014fb0a$export$dda18feb566b4c7a = (matchName)=>{
    const isArchivedPagesList = matchName === (0, $1NBp8.SPACE_ARCHIVED_PAGES).name;
    const isSpacePages = matchName === (0, $1NBp8.SPACE_PAGES).name;
    const isWhiteboard = matchName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    const skipContent = isArchivedPagesList || isSpacePages;
    return {
        skipContent: skipContent,
        isArchivedPagesList: isArchivedPagesList,
        isSpacePages: isSpacePages,
        isWhiteboard: isWhiteboard
    };
};

});

parcelRegister("hzkzq", function(module, exports) {

$parcel$export(module.exports, "CONTENT_STATUS_ARCHIVED", () => $b055c0b5c16164d3$export$41b2e06f27dfe96e);
$parcel$export(module.exports, "buildContentPath", () => $b055c0b5c16164d3$export$6b45500787cf696);
$parcel$export(module.exports, "filterAncestors", () => $b055c0b5c16164d3$export$d3865786a3f7be67);
$parcel$export(module.exports, "getEmojiFromPublishedPageProperties", () => $b055c0b5c16164d3$export$f6641c501f8a1aee);
$parcel$export(module.exports, "getEmojiFromDraftPageProperties", () => $b055c0b5c16164d3$export$e1cb12562674727b);
$parcel$export(module.exports, "getIsTextTruncated", () => $b055c0b5c16164d3$export$52c8bba571728790);

var $1NBp8 = parcelRequire("1NBp8");
const $b055c0b5c16164d3$export$41b2e06f27dfe96e = 'archived';
const $b055c0b5c16164d3$export$6b45500787cf696 = ({ contentId: contentId, contentSlug: contentSlug, contentType: contentType, isSpaceOverview: isSpaceOverview, query: query, spaceAlias: spaceAlias, spaceKey: spaceKey })=>{
    if (contentType === 'folder') return '#';
    let route;
    if (isSpaceOverview) route = (0, $1NBp8.SPACE_OVERVIEW);
    else switch(contentType){
        case 'blogpost':
            route = (0, $1NBp8.VIEW_BLOG);
            break;
        case 'page':
            route = (0, $1NBp8.VIEW_PAGE);
            break;
        case 'whiteboard':
            route = (0, $1NBp8.WHITEBOARD_BOARD);
            break;
        case 'database':
            route = (0, $1NBp8.DATABASE_VIEW);
            break;
        case 'embed':
            route = (0, $1NBp8.EMBED_VIEW);
            break;
        default:
            throw new Error(`Received an unexpected content type: '${contentType}'`);
    }
    return route.toUrl({
        contentId: contentId,
        contentSlug: contentSlug,
        spaceKey: spaceAlias || spaceKey
    }, {
        query: query
    });
};
const $b055c0b5c16164d3$export$d3865786a3f7be67 = ({ ancestors: ancestors, status: status }, spaceHomepageId)=>{
    if (!ancestors) return [];
    // If current page is archived, filter out non-archived ancestors
    if (status === $b055c0b5c16164d3$export$41b2e06f27dfe96e) ancestors = ancestors.filter((ancestor)=>ancestor && ancestor.status === $b055c0b5c16164d3$export$41b2e06f27dfe96e);
    else // technically array elements can be null
    ancestors = ancestors.filter((node)=>node);
    if (!ancestors.length) return ancestors;
    if (ancestors[0].id !== spaceHomepageId && ancestors[ancestors.length - 1].id === spaceHomepageId) return ancestors.reverse().slice(1);
    if (ancestors[0].id === spaceHomepageId) return ancestors.slice(1);
    return ancestors;
};
const $b055c0b5c16164d3$export$f6641c501f8a1aee = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$e1cb12562674727b = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$52c8bba571728790 = (textRef)=>{
    if (textRef.current) return textRef.current.scrollWidth > textRef.current.clientWidth;
    return false;
};

});

parcelRegister("i23fb", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsPicker", () => $bd2563cf85b1d596$export$8d34d157af825926);
/* BreadcrumbsPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $3gadb = parcelRequire("3gadb");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $jmjWc = parcelRequire("jmjWc");
parcelRequire("4K4h4");
var $iU0gR = parcelRequire("iU0gR");

var $kjXns = parcelRequire("kjXns");

var $gF3hr = parcelRequire("gF3hr");

var $gUqw5 = parcelRequire("gUqw5");

const $bd2563cf85b1d596$export$20cf4420e6ad0d7b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "y57pO",
    name: "LazyBreadrumbsEllipsisPopup",
    loader: async ()=>(await Promise.resolve((parcelRequire("8livF")))).BreadcrumbsAncestorsDropdownButton,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gF3hr.BreadcrumbsAncestorsDropdownButtonPlaceholder), null)
});
const $bd2563cf85b1d596$var$separatorStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtle',
    pointerEvents: 'none'
});
const $bd2563cf85b1d596$var$Separator = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $bd2563cf85b1d596$var$separatorStyles,
        paddingInlineStart: "space.100",
        paddingInlineEnd: "space.100"
    }, "/");
const $bd2563cf85b1d596$var$MAX_WIDTH_BREADCRUMBS = '570px';
const $bd2563cf85b1d596$var$breadcrumbsStyles = (0, $ecnYn.xcss)({
    minWidth: '0px',
    // needed for responsive breadcrumbs
    maxWidth: $bd2563cf85b1d596$var$MAX_WIDTH_BREADCRUMBS
});
const $bd2563cf85b1d596$var$BREADCRUMBS_ITEM_MIN_WIDTH = '16px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd2563cf85b1d596$var$BreadcrumbLinkWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1ul97vkz _tkqh1txw _bnh47vkz _3uv91osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd2563cf85b1d596$var$BreadcrumbLink = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCurrentPage: isCurrentPage, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4bfu18uv _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _1e0c1ule _o5721q9c _1ul97vkz _1bto1l2s _y3gn1h6o _1w901gjq _1fh11gjq _1f1j1gjq _1l5a1gjq",
            __cmplp.isCurrentPage ? "_80om73ad _p12f1mjv _1toh18uv _ow0718uv _el8t18uv _5jyqglyw _17rjglyw _12piglyw _mrqmnqa1 _1iqunqa1 _1lwpnqa1" : "_80omtlke _p12f1w81",
            __cmplp.className
        ])
    });
});
const $bd2563cf85b1d596$var$folderItemStyles = (0, $ecnYn.xcss)({
    flexShrink: 1,
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd2563cf85b1d596$var$FolderItem = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { compact: compact, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19itysnf _2rko1y44 _ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _18s8b0ox _syaz1gjq _k48pi7a9 _bfhk18uv _80omtlke _1ul97vkz _u1mb166n",
            __cmplp.compact ? "_1wyb1crf" : "_1wybdlk8",
            __cmplp.isSelected && "_syazaqb7 _bfhkfg4m _u1mbi1yw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd2563cf85b1d596$var$BreadrumbsEllipsisWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bd2563cf85b1d596$var$BreadcrumbItem = ({ title: title, href: href, onClick: onClick, ancestors: ancestors, isCurrentPage: isCurrentPage = false, contentType: contentType, contentId: contentId, compact: compact })=>{
    const intl = (0, $dBxQj.default)();
    const isFolder = contentType === 'folder';
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClickFolderDropdownItem = (content, depth)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'breadcrumb',
                source: 'breadcrumbsFolderButton',
                attributes: {
                    breadcrumbsTotal: ancestors.length + 1,
                    origin: 'view-page',
                    nestedDepth: depth + 2,
                    destination: (0, $kjXns.GenericBreadcrumbItemTitles).Ancestor,
                    titleLength: content.title.length
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadcrumbLinkWrapper, null, isFolder && contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gUqw5.BreadcrumbsFolderPopup), {
        contentId: contentId,
        isOpen: isOpen,
        onClose: ()=>{
            setIsOpen(false);
        },
        placement: "bottom-start",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                content: title,
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$FolderItem, {
                ...triggerProps,
                onClick: ()=>setIsOpen((v)=>!v),
                isSelected: isOpen,
                compact: compact
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iU0gR.ContentTreeIcon), {
                type: contentType,
                label: intl.formatMessage($bd2563cf85b1d596$var$i18n.folder),
                color: isOpen ? "var(--ds-text-selected, #0C66E4)" : undefined
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                as: "span",
                xcss: $bd2563cf85b1d596$var$folderItemStyles
            }, title)))),
        handleClickFolderDropdownItem: handleClickFolderDropdownItem
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: title,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadcrumbLink, {
        href: href,
        onClick: onClick,
        isCurrentPage: isCurrentPage
    }, title)));
};
function $bd2563cf85b1d596$export$8d34d157af825926({ ancestors: ancestors, contentTitle: contentTitle, spaceName: spaceName, spaceOverviewPath: spaceOverviewPath, compact: compact }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onBreadcrumbClick = (attributes)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'breadcrumb',
                    source: 'containerNavigation',
                    attributes: {
                        breadcrumbsTotal: ancestors.length + 1,
                        origin: 'view-page',
                        ...attributes
                    }
                }
            }).fire();
        };
    const handleClickAncestorBreadcrumb = (title, depth)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'breadcrumb',
                source: 'breadcrumbsEllipsisButton',
                attributes: {
                    breadcrumbsTotal: ancestors.length + 1,
                    origin: 'view-page',
                    nestedDepth: depth + 2,
                    destination: (0, $kjXns.GenericBreadcrumbItemTitles).Ancestor,
                    titleLength: title.length
                }
            }
        }).fire();
    };
    const renderInnerBreadcrumbs = (ancestors)=>{
        const dropdownAncestors = ancestors.slice(0, ancestors.length - 1);
        const lastInnerAncestor = ancestors[ancestors.length - 1];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, dropdownAncestors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$Separator, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadrumbsEllipsisWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$export$20cf4420e6ad0d7b, {
            ancestors: dropdownAncestors,
            handleClickAncestorBreadcrumb: handleClickAncestorBreadcrumb
        }))), lastInnerAncestor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$Separator, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadcrumbItem, {
            contentId: lastInnerAncestor.id,
            title: lastInnerAncestor.title,
            href: lastInnerAncestor.href,
            onClick: ()=>handleClickAncestorBreadcrumb(lastInnerAncestor.title, ancestors.length - 1),
            ancestors: ancestors,
            contentType: lastInnerAncestor.contentType,
            compact: compact
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $bd2563cf85b1d596$var$breadcrumbsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadcrumbItem, {
        title: spaceName,
        href: spaceOverviewPath,
        onClick: onBreadcrumbClick({
            nestedDepth: 1,
            destination: (0, $kjXns.GenericBreadcrumbItemTitles).Space,
            titleLength: spaceName.length
        }),
        ancestors: ancestors,
        compact: compact
    }), renderInnerBreadcrumbs(ancestors), contentTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$Separator, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($bd2563cf85b1d596$var$BreadcrumbItem, {
        title: contentTitle,
        href: "#",
        onClick: onBreadcrumbClick({
            nestedDepth: ancestors.length + 2,
            destination: (0, $kjXns.GenericBreadcrumbItemTitles).ContentTitle,
            titleLength: contentTitle.length
        }),
        ancestors: ancestors,
        isCurrentPage: true,
        compact: compact
    })));
}
const $bd2563cf85b1d596$var$i18n = (0, $2nPZH.defineMessages)({
    folder: {
        id: "breadcrumbs.picker.folder",
        defaultMessage: "Folder"
    }
});

});
parcelRegister("4K4h4", function(module, exports) {

$parcel$export(module.exports, "ContentTreeIconLoader", () => $61f85e63c6992485$export$e511f243d20dd25e);
$parcel$export(module.exports, "ContentTreeIcon", () => (parcelRequire("iU0gR")).ContentTreeIcon);

var $jmjWc = parcelRequire("jmjWc");

var $iU0gR = parcelRequire("iU0gR");

const $61f85e63c6992485$export$e511f243d20dd25e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g-l5_",
    name: "ContentTreeIconLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("iU0gR")))).ContentTreeIcon
});

});
parcelRegister("iU0gR", function(module, exports) {

$parcel$export(module.exports, "ContentTreeIcon", () => $3b6036244b1fd25e$export$160f5c89496b5ea9);

var $gwFzn = parcelRequire("gwFzn");

var $8jHAi = parcelRequire("8jHAi");

var $ZDq1z = parcelRequire("ZDq1z");

var $6B0jU = parcelRequire("6B0jU");

var $eG1e2 = parcelRequire("eG1e2");

var $5tmwS = parcelRequire("5tmwS");

var $e0ycV = parcelRequire("e0ycV");
const $3b6036244b1fd25e$export$160f5c89496b5ea9 = ({ label: label, color: color, spacing: spacing, type: type, isExpanded: isExpanded = false })=>{
    const contentTreeIconTypes = {
        page: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
        whiteboard: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        database: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        folder: isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($eG1e2))) : (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        liveDoc: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV)))
    };
    const icon = contentTreeIconTypes[type];
    const testId = `content-tree-icon${spacing !== 'none' ? `-${spacing}` : ''}-${type}${type === 'folder' && isExpanded ? '-open' : ''}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(icon, {
        spacing: spacing,
        label: label,
        color: color,
        testId: testId
    });
};

});
parcelRegister("eG1e2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::71e777a06bc65e4857d3584dfd940132>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaf5f0417c8d4f4a$var$_react = $aaf5f0417c8d4f4a$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $aaf5f0417c8d4f4a$var$_baseNew = $aaf5f0417c8d4f4a$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $aaf5f0417c8d4f4a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FolderOpen".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for open folders in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaf5f0417c8d4f4a$var$FolderOpenIcon = (props)=>/*#__PURE__*/ $aaf5f0417c8d4f4a$var$_react.default.createElement($aaf5f0417c8d4f4a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.5a.5.5 0 0 0-.5.5v9.473L3.148 6.98c.174-.582.71-.98 1.317-.98H12.5V4.75a.5.5 0 0 0-.5-.5H6.69L4.94 2.5zM14 6h.66c.921 0 1.582.888 1.317 1.77l-1.741 5.805A2 2 0 0 1 12.32 15H1.75A1.75 1.75 0 0 1 0 13.25V3a2 2 0 0 1 2-2h3.56l1.75 1.75H12a2 2 0 0 1 2 2zM2.758 13.5h9.562a.5.5 0 0 0 .479-.356L14.492 7.5H4.558z" clip-rule="evenodd"/>`
    }, props));
$aaf5f0417c8d4f4a$var$FolderOpenIcon.displayName = 'FolderOpenIcon';
var $aaf5f0417c8d4f4a$var$_default = module.exports.default = $aaf5f0417c8d4f4a$var$FolderOpenIcon;

});



parcelRegister("kjXns", function(module, exports) {

$parcel$export(module.exports, "GenericBreadcrumbItemTitles", () => $7658ec6bf458448d$export$4c099e5603d2ab62);
var $7658ec6bf458448d$export$4c099e5603d2ab62 = /*#__PURE__*/ function(GenericBreadcrumbItemTitles) {
    GenericBreadcrumbItemTitles["Blog"] = "BLOG";
    GenericBreadcrumbItemTitles["Overview"] = "OVERVIEW";
    GenericBreadcrumbItemTitles["Pages"] = "PAGES";
    GenericBreadcrumbItemTitles["People"] = "PEOPLE";
    GenericBreadcrumbItemTitles["Space"] = "SPACE";
    GenericBreadcrumbItemTitles["PersonalSpace"] = "PERSONAL_SPACE";
    GenericBreadcrumbItemTitles["ContentTitle"] = "CONTENT_TITLE";
    GenericBreadcrumbItemTitles["Ancestor"] = "ANCESTOR";
    GenericBreadcrumbItemTitles["BlogYear"] = "BLOG_YEAR";
    GenericBreadcrumbItemTitles["BlogMonth"] = "BLOG_MONTH";
    GenericBreadcrumbItemTitles["BlogDay"] = "BLOG_DAY";
    return GenericBreadcrumbItemTitles;
}({});

});

parcelRegister("gF3hr", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsAncestorsDropdownButtonPlaceholder", () => $e575f928bde0dbd7$export$d84187c34d9b4ae6);

var $gwFzn = parcelRequire("gwFzn");

var $9VJDA = parcelRequire("9VJDA");

var $8livF = parcelRequire("8livF");
const $e575f928bde0dbd7$export$d84187c34d9b4ae6 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8livF.BreadcrumbsEllipsisButton), {
        isSelected: false,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            label: "More",
            color: "var(--ds-icon, #44546F)"
        }),
        "data-vc": "breadcrumbs-ellipsis-button-placeholder"
    });
};

});
parcelRegister("8livF", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $09935b9249b2d0b1$export$a7357cdd1f0b0168);
$parcel$export(module.exports, "IndentIcon", () => $09935b9249b2d0b1$export$21e490f3e2d5b659);
$parcel$export(module.exports, "BreadcrumbsEllipsisButton", () => $09935b9249b2d0b1$export$e02399a773360b61);
$parcel$export(module.exports, "BreadcrumbsAncestorsDropdownButton", () => $09935b9249b2d0b1$export$5ebd70202eb13073);
/* BreadcrumbsAncestorsDropdownButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $eEA8O = parcelRequire("eEA8O");

var $lGgRw = parcelRequire("lGgRw");

var $9VJDA = parcelRequire("9VJDA");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $6B8C0 = parcelRequire("6B8C0");
const $09935b9249b2d0b1$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    moreBreadcrumbsLabel: {
        id: "breadcrumbs.ancestors.dropdown.button.label",
        defaultMessage: "More breadcrumbs"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $09935b9249b2d0b1$var$IndentIconPlaceholder = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});

const $09935b9249b2d0b1$export$21e490f3e2d5b659 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "64PW9",
    name: "IndentIcon",
    loader: async ()=>(await (parcelRequire("86qmQ"))).IndentIcon,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($09935b9249b2d0b1$var$IndentIconPlaceholder, null)
});
const $09935b9249b2d0b1$export$e02399a773360b61 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsblb34 _4t3i1txs _kqswh2mm _syaz1fxt _1xjxw1gv _vr2wstnw _g10tidpf _e2oogktf",
            __cmplp.isSelected ? "_11q7aqb7" : "_11q7aqb7",
            __cmplp.className
        ])
    });
});
const $09935b9249b2d0b1$export$5ebd70202eb13073 = ({ ancestors: ancestors, handleClickAncestorBreadcrumb: handleClickAncestorBreadcrumb })=>{
    const intl = (0, $dBxQj.default)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const handleClickAncestorDropdownItem = (ancestor, i)=>{
        handleClickAncestorBreadcrumb(ancestor.title, i);
        setIsOpen(false);
    };
    const contents = ancestors.map(({ id: id, title: title, href: href, contentType: contentType })=>({
            id: id,
            type: contentType,
            title: title,
            href: href
        }));
    const popupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6B8C0.BreadcrumbsContentMenu), {
            contents: contents,
            showIndentIcon: true,
            onLinkItemClick: handleClickAncestorDropdownItem
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: popupContent,
        shouldUseCaptureOnOutsideClick: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($09935b9249b2d0b1$export$e02399a773360b61, {
                ...triggerProps,
                appearance: "subtle",
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                    label: intl.formatMessage($09935b9249b2d0b1$export$a7357cdd1f0b0168.moreBreadcrumbsLabel),
                    "data-testid": "breadcrumbs-ellipsis-button-icon",
                    color: "var(--ds-icon, #44546F)"
                }),
                "data-vc": "breadcrumbs-ellipsis-button",
                ...ssrPlaceholderIdProp
            })
    });
};

});
parcelRegister("6B8C0", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsContentMenu", () => $8599c01e4bbf06e6$export$928fa58fefa4cb9e);
/* BreadcrumbsContentMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $56M4r = parcelRequire("56M4r");
var $cGtPE = parcelRequire("cGtPE");
var $2SlZp = parcelRequire("2SlZp");

var $6f0Oj = parcelRequire("6f0Oj");
var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");
parcelRequire("4K4h4");
var $iU0gR = parcelRequire("iU0gR");

var $jmjWc = parcelRequire("jmjWc");

var $iXzFq = parcelRequire("iXzFq");

var $cLo2u = parcelRequire("cLo2u");

var $dPJCf = parcelRequire("dPJCf");

const $8599c01e4bbf06e6$var$IndentIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "WRkwL",
    name: "IndentIcon",
    loader: async ()=>(await (parcelRequire("86qmQ"))).IndentIcon,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8599c01e4bbf06e6$var$IndentIconPlaceholder, null)
});
const $8599c01e4bbf06e6$export$928fa58fefa4cb9e = ({ contents: contents, showIndentIcon: showIndentIcon, onLinkItemClick: onLinkItemClick, hasMore: hasMore })=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingBlock: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2SlZp.default), {
        maxWidth: 280,
        minWidth: 280,
        onClick: (e)=>e.stopPropagation()
    }, contents.map((content, i)=>{
        const isFolder = content.type === 'folder';
        const iconBefore = showIndentIcon ? i > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8599c01e4bbf06e6$var$IndentIcon, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8599c01e4bbf06e6$var$IndentIconPlaceholder, null) : undefined;
        const onFolderItemClick = ()=>{
            onLinkItemClick?.(content, i);
            if (spaceKey) {
                const destinationUrl = (0, $iXzFq.getUrlForContentType)({
                    contentType: 'folder',
                    contentId: content.id,
                    spaceKey: spaceKey
                });
                destinationUrl && push(destinationUrl);
            }
        };
        if (isFolder) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8599c01e4bbf06e6$var$FolderItem, {
            key: i,
            title: content.title,
            iconBefore: iconBefore,
            onClick: onFolderItemClick
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8599c01e4bbf06e6$var$CustomLinkItem, {
            key: i,
            iconBefore: iconBefore,
            "data-testid": "ancestor-breadcrumb-item",
            href: content.href,
            onClick: ()=>onLinkItemClick?.(content, i)
        }, content.title);
    })), hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        paddingInline: "space.150",
        paddingBlock: "space.100",
        xcss: $8599c01e4bbf06e6$var$subtlestText
    }, "..."));
};
const $8599c01e4bbf06e6$var$FolderItem = ({ title: title, iconBefore: iconBefore, onClick: onClick })=>{
    const intl = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($8599c01e4bbf06e6$var$CustomButtonItem, {
        iconBefore: iconBefore,
        "data-testid": "ancestor-breadcrumb-item",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $8599c01e4bbf06e6$var$folderIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iU0gR.ContentTreeIcon), {
        type: "folder",
        label: intl.formatMessage($8599c01e4bbf06e6$var$i18n.folder),
        spacing: "spacious"
    })), title));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8599c01e4bbf06e6$var$CustomLinkItem = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $cGtPE.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_ca0qc4v4 _u5f319el _n3tdc4v4 _19bv19el _1tke1h67 _4t3izwfg _13oz18uv _l40u8stv _4yqlnqa1 _6ehmyh40 _1tjq1gjq _ecb3myb0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8599c01e4bbf06e6$var$CustomButtonItem = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $56M4r.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_ca0qc4v4 _u5f319el _n3tdc4v4 _19bv19el _1tke1h67 _4t3izwfg _6ehmyh40 _1tjq1gjq _ecb3myb0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8599c01e4bbf06e6$var$IndentIconPlaceholder = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
});
const $8599c01e4bbf06e6$var$folderIconWrapperStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.negative.050'
});
const $8599c01e4bbf06e6$var$subtlestText = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $8599c01e4bbf06e6$var$i18n = (0, $2nPZH.defineMessages)({
    folder: {
        id: "breadcrumbs.picker.folder",
        defaultMessage: "Folder"
    }
});

});
parcelRegister("iXzFq", function(module, exports) {

$parcel$export(module.exports, "getUrlForContentType", () => $71e3d8e13a87be5f$export$11b68a3633074ac0);

var $jlIaF = parcelRequire("jlIaF");
var $1NBp8 = parcelRequire("1NBp8");
const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};

});

parcelRegister("86qmQ", function(module, exports) {

let $5e63564c3334f397$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $5e63564c3334f397$var$load("1TkAG").then(()=>parcelRequire('ddPDC'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});






parcelRegister("gUqw5", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsFolderPopup", () => $5af50a45bc36e00c$export$7d591fd4f4b1c7b1);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $diswb = parcelRequire("diswb");

var $lGgRw = parcelRequire("lGgRw");

var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $9hlns = parcelRequire("9hlns");

var $dIouf = parcelRequire("dIouf");

var $jlIaF = parcelRequire("jlIaF");

var $6B8C0 = parcelRequire("6B8C0");
const $5af50a45bc36e00c$var$BreadcrumbsFolderPopupBreadcrumbsFolderChildrenQuery = (0, $d2LG0.default)`query BreadcrumbsFolderPopupBreadcrumbsFolderChildrenQuery($contentId:ID!){ptpage(id:$contentId status:[CURRENT]){id children(first:5){nodes{id title type links{webui}emojiTitlePublished:properties(key:"emoji-title-published"){nodes{id key value version{number}}}}pageInfo{hasNextPage endCursor}}}}`;
const $5af50a45bc36e00c$export$7d591fd4f4b1c7b1 = ({ contentId: contentId, isOpen: isOpen, onClose: onClose, trigger: trigger, placement: placement, handleClickFolderDropdownItem: handleClickFolderDropdownItem })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        trigger: trigger,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($5af50a45bc36e00c$var$BreadcrumbsFolderContent, {
                contentId: contentId,
                handleClickFolderDropdownItem: handleClickFolderDropdownItem
            }),
        isOpen: isOpen,
        onClose: onClose,
        placement: placement
    });
};
const $5af50a45bc36e00c$var$BreadcrumbsFolderContent = ({ contentId: contentId, handleClickFolderDropdownItem: handleClickFolderDropdownItem })=>{
    const { loading: loading, data: data, error: error } = (0, $diswb.useQuery)($5af50a45bc36e00c$var$BreadcrumbsFolderPopupBreadcrumbsFolderChildrenQuery, {
        variables: {
            contentId: contentId
        }
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $5af50a45bc36e00c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9hlns.default), {
        size: "large"
    }));
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $5af50a45bc36e00c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $5af50a45bc36e00c$var$i18n.error)));
    const contents = data?.ptpage?.children?.nodes?.filter($5af50a45bc36e00c$var$isTruthy).map((c)=>({
            id: c.id,
            type: c.type || '',
            title: c.title || '',
            href: `${0, $jlIaF.CONTEXT_PATH}${c.links?.webui}`
        })) || [];
    const hasMore = data?.ptpage?.children?.pageInfo?.hasNextPage;
    if (!contents.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $5af50a45bc36e00c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $5af50a45bc36e00c$var$i18n.empty));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6B8C0.BreadcrumbsContentMenu), {
        contents: contents,
        showIndentIcon: false,
        hasMore: hasMore,
        onLinkItemClick: handleClickFolderDropdownItem
    });
};
const $5af50a45bc36e00c$var$containerStyles = (0, $ecnYn.xcss)({
    width: '280px',
    paddingInline: 'space.150',
    paddingBlock: 'space.500',
    color: 'color.text.subtlest'
});
function $5af50a45bc36e00c$var$isTruthy(value) {
    return value !== null && value !== undefined;
}
const $5af50a45bc36e00c$var$i18n = (0, $2nPZH.defineMessages)({
    error: {
        id: "breadcrumbs.folder.error",
        defaultMessage: "Error loading folder contents"
    },
    empty: {
        id: "breadcrumbs.folder.empty",
        defaultMessage: "There\u2019s nothing in this folder yet."
    }
});

});


parcelRegister("5Vf1r", function(module, exports) {

$parcel$export(module.exports, "BREADCRUMBS_MODES", () => $7c978e5ad74fbe60$export$14e8342ddf0a4616);
$parcel$export(module.exports, "BreadcrumbsWithSpaceNameDropdown", () => $7c978e5ad74fbe60$export$c71a066c29807b48);
/* BreadcrumbsWithSpaceNameDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $ghftu = parcelRequire("ghftu");

var $5izcQ = parcelRequire("5izcQ");

var $inPa6 = parcelRequire("inPa6");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $lGgRw = parcelRequire("lGgRw");

var $3gadb = parcelRequire("3gadb");

var $9wGTI = parcelRequire("9wGTI");
parcelRequire("ilxH8");
var $hBWQz = parcelRequire("hBWQz");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $kqIWy = parcelRequire("kqIWy");
var $bMPhU = parcelRequire("bMPhU");

var $irVI7 = parcelRequire("irVI7");
var $gfIPU = parcelRequire("gfIPU");
var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");

var $dIouf = parcelRequire("dIouf");

var $1NBp8 = parcelRequire("1NBp8");

var $dPJCf = parcelRequire("dPJCf");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $bCECL = parcelRequire("bCECL");

var $ePiuX = parcelRequire("ePiuX");

var $hzkzq = parcelRequire("hzkzq");

const $7c978e5ad74fbe60$var$BreadcrumbsDropdownContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "d_JWZ",
    name: "BreadcrumbsDropdownContent",
    loader: async ()=>(await (parcelRequire("1N6iB"))).BreadcrumbsDropdownContent
});

const $7c978e5ad74fbe60$var$BreadcrumbsPlaceholder = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YZZqh",
    name: "BreadcrumbsPlaceholder",
    loader: async ()=>(await Promise.resolve((parcelRequire("eCJDV")))).BreadcrumbsPlaceholder
});
const $7c978e5ad74fbe60$var$separatorStyles = null;
const $7c978e5ad74fbe60$var$hiddenStyles = null;
const $7c978e5ad74fbe60$var$hiddenContentTitleStyles = null;
const $7c978e5ad74fbe60$var$hideSeparatorStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbsStyles = (0, $ecnYn.xcss)({
    minWidth: '32px',
    // needed for responsive breadcrumbs, 32px is the width of the chevron button
    alignItems: 'center',
    flex: '0 1 auto',
    gap: 'space.100'
});
const $7c978e5ad74fbe60$var$fadedSpaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$spaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$noEllipsisStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthBreadcrumbsDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthOnlyContentTitleTriggerStyles = null;
const $7c978e5ad74fbe60$var$currentPageBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$currentPageLinkBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$contentTitleStyles = null;
const $7c978e5ad74fbe60$var$chevronHoverButtonStyles = (0, $ecnYn.xcss)({
    width: '32px',
    minWidth: '32px',
    height: '32px',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.background.neutral.subtle',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $7c978e5ad74fbe60$export$14e8342ddf0a4616 = /*#__PURE__*/ function(BREADCRUMBS_MODES) {
    BREADCRUMBS_MODES["ONLY_CONTENT_TITLE"] = "ONLY_CONTENT_TITLE";
    BREADCRUMBS_MODES["ONLY_SPACE_NAME"] = "ONLY_SPACE_NAME";
    BREADCRUMBS_MODES["FULL"] = "FULL";
    BREADCRUMBS_MODES["HIDDEN"] = "HIDDEN";
    return BREADCRUMBS_MODES;
}({});
const $7c978e5ad74fbe60$export$c71a066c29807b48 = ({ contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: testId = 'breadcrumbs-with-space-name-dropdown', showInlineRename: showInlineRename = false, shouldDisableMoveButton: shouldDisableMoveButton = false, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $gwFzn.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const breadcrumbsButtonTextRef = (0, $gwFzn.useRef)(null);
    const [spaceNameIsTruncated, setSpaceNameIsTruncated] = (0, $gwFzn.useState)(false);
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isSideNavCollapsed = (0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LEFT_SIDEBAR_COLLAPSED) === 'collapsed';
    (0, $gwFzn.useEffect)(()=>{
        // whenever the width of the space name breadcrumbs changes, check if it is truncated to apply the fade css
        const resizeObserver = new ResizeObserver(()=>{
            setSpaceNameIsTruncated((0, $hzkzq.getIsTextTruncated)(breadcrumbsButtonTextRef));
        });
        const currentBreadcrumb = breadcrumbsButtonTextRef.current;
        if (currentBreadcrumb) resizeObserver.observe(currentBreadcrumb);
        return ()=>{
            if (currentBreadcrumb) resizeObserver.unobserve(currentBreadcrumb); // Use the stored reference
            resizeObserver.disconnect();
        };
    }, [
        spaceKey,
        isSideNavCollapsed
    ]); // Note don't check for loading as when refreshing data we will get data={...} and loading=true
    // In this case if we display the placeholder it will flash before the data is displayed
    // We should continue render with existing data and then update when the new data is available
    if (error || !spaceData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
        error: error
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null));
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const contentTitleToRender = contentTitle === '' ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
    const shouldOpenDropdown = contentTitleToRender || showInlineRename;
    const shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
    const spaceOverviewPath = (0, $hzkzq.buildContentPath)({
        contentType: 'page',
        isSpaceOverview: true,
        query: spaceHomepageId ? {
            [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
        } : undefined,
        spaceAlias: spaceData.alias,
        spaceKey: spaceKey
    });
    const handleBreadcrumbDropdownTriggerClick = ()=>{
        if (shouldOpenDropdown) {
            if (!isBreadcrumbsPopupOpen) {
                experienceTracker.start({
                    name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'opened',
                        actionSubject: 'breadcrumbsDropdown',
                        source: 'breadcrumbs',
                        attributes: {
                            isContentWrapper: (0, $9wGTI.fg)('confluence_frontend_object_header')
                        }
                    }
                }).fire();
            }
            setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
        } else push(spaceOverviewPath);
    };
    const popupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
            spaceKey: spaceKey,
            contentId: contentId,
            closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
            spaceOverviewPath: spaceOverviewPath,
            shouldDisableMoveButton: shouldDisableMoveButton,
            contentTitle: contentTitleToRender
        });
    };
    const closeDropdownOnClickOfBreadcrumbItem = ()=>{
        setIsBreadcrumbsPopupOpen(false);
    };
    const preloadBreadcrumbsDropdownOnSpaceNameHover = ()=>{
        (0, $ePiuX.preloadBreadcrumbsDropdown)({
            spaceKey: spaceKey,
            contentId: contentId
        });
    };
    const renderContentTitle = ()=>{
        const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
            href: contentLink,
            className: (0, $35pXk.default)([
                "_1reo15vq _18m915vq _11c8140y _o5721q9c _1bto1l2s _1ul91tcg _syaz1fxt _10531fxt _1vhv1fxt _1m0aglyw"
            ])
        }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            className: (0, $35pXk.default)([
                "_1reo15vq _18m915vq _11c8140y _o5721q9c _1bto1l2s _1ul91tcg _syaz1fxt _1m0aglyw"
            ])
        }, contentTitleToRender);
        const wrappedTitleElement = (0, $9wGTI.fg)('confluence_frontend_object_header') ? titleElement : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
            name: (0, $hBWQz.LIVE_DOC_MODES_TOGGLE_TARGET)
        }, titleElement);
        if ((0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
            id: "breadcrumbs-content-title",
            className: (0, $35pXk.default)([
                "_zulpu2gc _1reo15vq _18m915vq _v564glyw _1e0c1txw _4cvr1h6o _tzy4kb7n _p12f1c3h",
                (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_tzy4idpf _p12fidpf"
            ])
        }, (contentType === 'page' || contentType === 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            color: "var(--ds-text, #172B4D)"
        }), wrappedTitleElement);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, (contentType === 'page' || contentType === 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            color: "var(--ds-text, #172B4D)"
        }), wrappedTitleElement);
    };
    const renderSpaceName = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            id: "breadcrumbs-space-name",
            ref: breadcrumbsButtonTextRef,
            className: (0, $35pXk.default)([
                "_1reo15vq _18m915vq _11c82smr _1bto1l2s _1bsb1osq _o5721q9c _p12f1osq",
                shouldOpenDropdown && "_1bton7od",
                shouldOpenDropdown && spaceNameIsTruncated && "_1nwp1wyi _1w801wyi",
                (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && (0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation') && "_1e0cglyw"
            ])
        }, spaceName);
    };
    const renderSeparator = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            id: "breadcrumbs-separator",
            className: (0, $35pXk.default)([
                "_syaz1gjq _lcxvglyw _1o9zidpf _2hwx1b66 _18u01b66",
                !showInlineRename && "_1m0aglyw",
                displayMode != "FULL" && (0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation') && "_1e0cglyw"
            ])
        }, "/");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $7c978e5ad74fbe60$var$breadcrumbsStyles,
        testId: testId,
        "data-vc": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isBreadcrumbsPopupOpen,
        onClose: ()=>setIsBreadcrumbsPopupOpen(false),
        placement: "bottom-start",
        content: popupContent,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("button", {
                id: "breadcrumbs-dropdown-chevron-button",
                onClick: handleBreadcrumbDropdownTriggerClick,
                onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                "aria-label": "Breadcrumbs",
                ...triggerProps,
                ...ssrPlaceholderIdProp,
                className: (0, $35pXk.default)([
                    "_2rko1y44 _19it3acm _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjcidpf _18zridpf _1e0c1o8l _80omtlke _1o9zidpf _1bsb1osq _bfhk1w7a _syaz131l _f8pj1gjq _mizu1p6i _1ah3v77o _9oik18uv _1bnx8stv _jf4cnqa1 _30l31gjq _9h8h1fxt",
                    shouldOpenDropdown && "_p12fp3fh _1bsbn7od _8fz6ucft",
                    displayMode === "ONLY_CONTENT_TITLE" && "_p12f1osq _1bto1l2s _8fz61osq",
                    displayMode === "HIDDEN" && (0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation') && "_1e0cglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
                alignItems: "center",
                gap: "space.100"
            }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                content: intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                hideTooltipOnClick: true
            }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                    xcss: $7c978e5ad74fbe60$var$chevronHoverButtonStyles,
                    ...tooltipProps
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #626F86)",
                    size: "small"
                }))), displayMode !== "ONLY_CONTENT_TITLE" || (0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation') ? renderSpaceName() : showInlineRename ? null : renderContentTitle()))
    }), (displayMode === "FULL" || (0, $9wGTI.fg)('confluence_frontend_breadcrumbs_dom_manipulation')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, shouldOpenDropdown && renderSeparator(), shouldShowCurrentContentTitle && renderContentTitle()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }));
};
const $7c978e5ad74fbe60$var$i18n = (0, $2nPZH.defineMessages)({
    untitledPage: {
        id: "breadcrumbs.dropdown.untitled-page.default-title",
        defaultMessage: "Untitled"
    },
    breadcrumbsChevronButtonTooltip: {
        id: "breadcrumbs.dropdown.button.chevron.tooltip",
        defaultMessage: "Show navigation path"
    }
});

});
parcelRegister("ilxH8", function(module, exports) {

$parcel$export(module.exports, "LiveDocSpotlightsTour", () => $499927cf1e2993ab$export$4a8ffe5265891658);
$parcel$export(module.exports, "LIVE_DOC_MODES_TOGGLE_TARGET", () => (parcelRequire("hBWQz")).LIVE_DOC_MODES_TOGGLE_TARGET);
$parcel$export(module.exports, "LIVE_DOC_SHARE_BUTTON_TARGET", () => (parcelRequire("hBWQz")).LIVE_DOC_SHARE_BUTTON_TARGET);
$parcel$export(module.exports, "LiveDocSpotlightsTourManager", () => (parcelRequire("77ZBJ")).LiveDocSpotlightsTourManager);

var $jmjWc = parcelRequire("jmjWc");

var $hBWQz = parcelRequire("hBWQz");

var $77ZBJ = parcelRequire("77ZBJ");

const $499927cf1e2993ab$export$4a8ffe5265891658 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4l1jb",
    name: "LiveDocSpotlightsTour",
    loader: async ()=>(await (parcelRequire("aOiF8"))).LiveDocSpotlightsTour
});

});
parcelRegister("hBWQz", function(module, exports) {

$parcel$export(module.exports, "LIVE_DOC_MODES_TOGGLE_TARGET", () => $ed86ee9224b6e932$export$f7d00e78fda956f1);
$parcel$export(module.exports, "LIVE_DOC_SHARE_BUTTON_TARGET", () => $ed86ee9224b6e932$export$789d6d0dffe2f1d7);
$parcel$export(module.exports, "LiveDocSpotlightsTourComponent", () => $ed86ee9224b6e932$export$58b0d6e3b6c16458);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $2Fndw = parcelRequire("2Fndw");

var $inPa6 = parcelRequire("inPa6");

var $lsxnT = parcelRequire("lsxnT");

var $9wGTI = parcelRequire("9wGTI");

var $3J7nf = parcelRequire("3J7nf");

var $1Wjeq = parcelRequire("1Wjeq");
const $ed86ee9224b6e932$var$LIVE_DOC_MODES_TOGGLE_SPOTLIGHT_ID = 'live-doc-modes-toggle-spotlight';
const $ed86ee9224b6e932$var$LIVE_DOC_SHARE_BUTTON_SPOTLIGHT_ID = 'live-doc-share-button-spotlight';
const $ed86ee9224b6e932$export$f7d00e78fda956f1 = 'live-doc-modes-toggle-spotlight-target';
const $ed86ee9224b6e932$export$789d6d0dffe2f1d7 = 'live-doc-share-button-spotlight-target';
const $ed86ee9224b6e932$var$ACTION_SUBJECT_IDS = [
    'liveDocTourEditToggle',
    'liveDocTourShareMenu'
];
var $ed86ee9224b6e932$var$MessageType = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}($ed86ee9224b6e932$var$MessageType || {});
const $ed86ee9224b6e932$export$58b0d6e3b6c16458 = ()=>{
    const [activeSpotlight, setActiveSpotlight] = (0, $gwFzn.useState)(null);
    const [messageType, setMessageType] = (0, $gwFzn.useState)("engagement");
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { liveDocTour: { complete: complete } } = (0, $3J7nf.useLiveDocChangeboarding)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const start = ()=>setActiveSpotlight(0);
    const next = ()=>{
        setMessageType("transactional");
        setActiveSpotlight((activeSpotlight || 0) + 1);
    };
    const back = ()=>setActiveSpotlight((activeSpotlight || 1) - 1);
    const end = ()=>{
        setActiveSpotlight(null);
        complete();
    };
    (0, $gwFzn.useEffect)(()=>{
        start();
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        if (activeSpotlight !== null && messageType === "transactional") createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'spotlight',
                actionSubjectId: $ed86ee9224b6e932$var$ACTION_SUBJECT_IDS[activeSpotlight],
                source: 'liveDocTour'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        messageType,
        activeSpotlight
    ]);
    const onClose = ({ source: source })=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: source
            }
        }).fire();
        end();
    };
    const spotlights = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Spotlight, {
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1Wjeq.CrossIconCloseButton), {
                onClose: ()=>onClose({
                        source: 'liveDocTourEditToggleSpotlight'
                    }),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $ed86ee9224b6e932$var$editorSpotlight.dismiss)
            }),
            actions: [
                {
                    onClick: ()=>{
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'next',
                                source: 'liveDocTourEditToggleSpotlight'
                            }
                        }).fire();
                        next();
                    },
                    text: formatMessage($ed86ee9224b6e932$var$editorSpotlight.next)
                }
            ],
            dialogPlacement: (0, $9wGTI.fg)('confluence_frontend_object_header') ? 'bottom right' : 'bottom left',
            dialogWidth: 320,
            heading: formatMessage($ed86ee9224b6e932$var$editorSpotlight.heading),
            target: $ed86ee9224b6e932$export$f7d00e78fda956f1,
            messageId: $ed86ee9224b6e932$var$LIVE_DOC_MODES_TOGGLE_SPOTLIGHT_ID,
            messageType: messageType,
            key: $ed86ee9224b6e932$var$LIVE_DOC_MODES_TOGGLE_SPOTLIGHT_ID,
            targetRadius: 4,
            shouldWatchTarget: true,
            onMessageDisposition: (disposition)=>{
                if (disposition === 'started') createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'shown',
                        actionSubject: 'spotlight',
                        actionSubjectId: $ed86ee9224b6e932$var$ACTION_SUBJECT_IDS[0],
                        source: 'liveDocTour'
                    }
                }).fire();
            },
            targetBgColor: "var(--ds-surface, #FFFFFF)"
        }, formatMessage($ed86ee9224b6e932$var$editorSpotlight.body)),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Spotlight, {
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1Wjeq.CrossIconCloseButton), {
                onClose: ()=>onClose({
                        source: 'liveDocTourShareMenuSpotlight'
                    }),
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $ed86ee9224b6e932$var$editorSpotlight.dismiss)
            }),
            actions: [
                {
                    onClick: ()=>{
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'ok',
                                source: 'liveDocTourShareMenuSpotlight'
                            }
                        }).fire();
                        end();
                    },
                    text: formatMessage($ed86ee9224b6e932$var$collabSpotlight.ok)
                },
                {
                    onClick: ()=>{
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: 'back',
                                source: 'liveDocTourShareMenuSpotlight'
                            }
                        }).fire();
                        back();
                    },
                    text: formatMessage($ed86ee9224b6e932$var$collabSpotlight.back)
                }
            ],
            dialogPlacement: "bottom right",
            dialogWidth: 320,
            heading: formatMessage($ed86ee9224b6e932$var$collabSpotlight.heading),
            target: $ed86ee9224b6e932$export$789d6d0dffe2f1d7,
            messageId: $ed86ee9224b6e932$var$LIVE_DOC_SHARE_BUTTON_SPOTLIGHT_ID,
            messageType: "transactional",
            key: $ed86ee9224b6e932$var$LIVE_DOC_SHARE_BUTTON_SPOTLIGHT_ID,
            targetRadius: 4,
            targetBgColor: "var(--ds-surface, #FFFFFF)"
        }, formatMessage($ed86ee9224b6e932$var$collabSpotlight.body))
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Fndw.default), null, activeSpotlight === null ? null : spotlights[activeSpotlight]);
};
const $ed86ee9224b6e932$var$editorSpotlight = (0, $2nPZH.defineMessages)({
    heading: {
        id: "onboarding-live-doc-changeboarding.editorSpotlight.heading",
        defaultMessage: "Launch into work with a live doc"
    },
    body: {
        id: "onboarding-live-doc-changeboarding.editorSpotlight.body",
        defaultMessage: "Make instant edits without having to publish."
    },
    dismiss: {
        id: "onboarding-live-doc-changeboarding.editorSpotlight.dismiss",
        defaultMessage: "Dismiss"
    },
    next: {
        id: "onboarding-live-doc-changeboarding.editorSpotlight.next",
        defaultMessage: "Next"
    },
    stepOfSteps: {
        id: "onboarding-live-doc-changeboarding.editorSpotlight.stepOfSteps",
        defaultMessage: "{step}/{steps}"
    },
    xButtonLabel: {
        id: "onboarding-live-doc-changeboarding.editorSpotlight.x-button-label",
        defaultMessage: "Close"
    }
});
const $ed86ee9224b6e932$var$collabSpotlight = (0, $2nPZH.defineMessages)({
    heading: {
        id: "onboarding-live-doc-changeboarding.collabSpotlight.heading",
        defaultMessage: "Open for collaboration"
    },
    body: {
        id: "onboarding-live-doc-changeboarding.collabSpotlight.body",
        defaultMessage: "Anyone can view and edit this live doc. Make it private anytime."
    },
    back: {
        id: "onboarding-live-doc-changeboarding.collabSpotlight.back",
        defaultMessage: "Back"
    },
    ok: {
        id: "onboarding-live-doc-changeboarding.collabSpotlight.ok",
        defaultMessage: "Got it"
    },
    gotIt: {
        id: "onboarding-live-doc-changeboarding.collabSpotlight.got-it",
        defaultMessage: "Got it"
    },
    stepOfSteps: {
        id: "onboarding-live-doc-changeboarding.collabSpotlight.stepOfSteps",
        defaultMessage: "{step}/{steps}"
    },
    xButtonLabel: {
        id: "onboarding-live-doc-changeboarding.collabSpotlight.x-button-label",
        defaultMessage: "Close"
    }
});

});
parcelRegister("1Wjeq", function(module, exports) {

$parcel$export(module.exports, "CrossIconCloseButton", () => $85eb760c47c1e1af$export$f56d620db6064703);

var $gwFzn = parcelRequire("gwFzn");

var $1qfLF = parcelRequire("1qfLF");

var $lnqHu = parcelRequire("lnqHu");
const $85eb760c47c1e1af$export$f56d620db6064703 = ({ onClose: onClose, label: label })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), {
                ...iconProps,
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }),
        appearance: "subtle",
        label: label,
        onClick: onClose
    });
};

});


parcelRegister("77ZBJ", function(module, exports) {

$parcel$export(module.exports, "LiveDocSpotlightsTourManager", () => $38d538eea737a03f$export$1b4676a0f6b18dfb);

var $gwFzn = parcelRequire("gwFzn");

var $6cnUO = parcelRequire("6cnUO");

var $9wGTI = parcelRequire("9wGTI");
const $38d538eea737a03f$export$1b4676a0f6b18dfb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ children: children })=>{
    // Remove <SpotlightManager> when cc_modernize_ga_changeboarding is enabled
    // This will allow the Modernize changeboarding including Nav4 to be managed by the <SpotlightManager> in PageLayout level
    // We still keep the <SpotlightManager> in place for exiting Live Doc changeboarding EAP and Open beta users.
    // We will remove this `LiveDocSpotlightsTourManager` when cc_modernize_ga_changeboarding is rolled out
    if ((0, $9wGTI.fg)('cc_modernize_ga_changeboarding')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), null, children);
});

});

parcelRegister("aOiF8", function(module, exports) {

let $7ded0ce3f3a396ff$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7ded0ce3f3a396ff$var$load("aLenh").then(()=>parcelRequire('jgjMq'));

});


parcelRegister("bMPhU", function(module, exports) {

$parcel$export(module.exports, "useSpaceHomepageId", () => $337a96ad81fe0f87$export$a1e0cd72fc64ef6);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $ep3mz = parcelRequire("ep3mz");
const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    const { data: data } = (0, $diswb.useQuery)((0, $d2LG0.default)`query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id}}}`, {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey
    });
    return data?.space?.homepage?.id || undefined;
};

});

parcelRegister("ePiuX", function(module, exports) {

$parcel$export(module.exports, "preloadBreadcrumbsDropdown", () => $e956eba1dd4bb7db$export$e5d3f19aa88b9c61);

var $dYU3e = parcelRequire("dYU3e");

var $iibKQ = parcelRequire("iibKQ");
function $e956eba1dd4bb7db$export$e5d3f19aa88b9c61({ spaceKey: spaceKey, contentId: contentId }) {
    return (0, $dYU3e.query)({
        query: (0, $iibKQ.ModernizedBreadcrumbsQuery),
        variables: {
            spaceKey: spaceKey,
            contentId: contentId,
            skipContent: !contentId
        }
    });
}

});
parcelRegister("iibKQ", function(module, exports) {

$parcel$export(module.exports, "ModernizedBreadcrumbsQuery", () => $fe32fc813e468bd2$export$9c8d605c16743dd0);

var $d2LG0 = parcelRequire("d2LG0");
const $fe32fc813e468bd2$export$9c8d605c16743dd0 = (0, $d2LG0.default)`query ModernizedBreadcrumbsQuery($spaceKey:String!$contentId:ID$skipContent:Boolean!){space(key:$spaceKey){alias id name icon{path}homepage{id}}content(id:$contentId status:["current" "draft" "archived"])@skip(if:$skipContent){nodes{id type subType status properties(keys:["emoji-title-published" "emoji-title-draft"]){nodes{id key value}}ancestors{id type subType title status properties(keys:["emoji-title-published"]){nodes{id key value}}}}}}`;

});


parcelRegister("1N6iB", function(module, exports) {

let $14df40ec52e90fe0$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $14df40ec52e90fe0$var$load("7Q0UC"),
    $14df40ec52e90fe0$var$load("1GyAj")
]).then(()=>parcelRequire('auDgK'));

});


parcelRegister("lKXie", function(module, exports) {

let $fd6be33d4f428578$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fd6be33d4f428578$var$load("2uoBF"),
    $fd6be33d4f428578$var$load("b6JBs")
]).then(()=>parcelRequire('g3Wvh'));

});



var $7e8c9ab8b94205ed$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"75RiE\",\"nativeEditorComponentsPreloader.8e0e35b2.js\",\"b6JBs\",\"CompanyHubBreadcrumbs.45a471c4.js\",\"lpcEN\",\"ChangeHubNameDialog.b9b11cad.js\",\"70fET\",\"hub-hero-image.d6790ccb.png\",\"4Pn6Z\",\"modal.ade0851c.js\",\"aZinD\",\"vendors.d807c867.js\",\"c6MKV\",\"stable_vendors.c60294fd.js\",\"i6hfz\",\"modal.99fe2918.js\",\"2uoBF\",\"modal.13935b90.js\",\"1GyAj\",\"BreadcrumbsDropdownContent.87507526.js\",\"36rXN\",\"MovePageDialog.5a6fe1e0.js\",\"lnCW7\",\"ExternalCollaboratorInSpaceNotify.0768fceb.js\",\"j02A7\",\"ViewExternalCollaboratorsLink.aaaf4419.js\",\"l5XQ1\",\"ViewSpaceExternalCollaboratorsDialog.34d928dc.js\",\"5joXW\",\"GuestRequestToUpgradeToUser.7da96066.js\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.b5de2b35.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"h4Nf7\",\"ExternalUserLozenge.814e73a5.js\",\"3wN5D\",\"ExternalSpaceLozenge.abcae868.js\",\"j3iEF\",\"CommentAddPromptNudgeText.5f1b8fa4.js\",\"lwUFR\",\"RequestAccessForUnassignedGuest.9a35b3a7.js\",\"aad5M\",\"Collaboration-Bike.8735a1c6.svg\",\"7Ni3R\",\"GuestOnboardingModal.3f76c08f.js\",\"WYAWv\",\"Guest-Onboarding-Light.8e788fbd.svg\",\"4rpM2\",\"Guest-Onboarding-Dark.f055cab3.svg\",\"hA2SB\",\"GroupAndUserItem.a66f5eef.js\",\"hwiu3\",\"NavigationLockout.6ac66ad3.js\",\"iHlO3\",\"empty-filter.16dda5ac.svg\",\"4aLlP\",\"cross-circle.78f6ec0b.js\",\"7Q0UC\",\"modal.007b2adc.js\",\"6ZgMI\",\"modal.6c7f3a5e.js\",\"3XMOA\",\"modal.823cef12.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.a0f1e2bf.js\",\"ktyyJ\",\"TrialFlags.5066712f.js\",\"cmcKh\",\"TrialFlags.0d9edc2f.js\",\"4yUSc\",\"PremiumLozenge.b5051b8b.js\",\"ePA5l\",\"Lozenge.156d3474.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"fqBFU\",\"ReverseTrialLozenge.4e921999.js\",\"1HAEl\",\"ReverseTrialListItem.7699333a.js\",\"kPQBd\",\"CompletionFlag.d73c19f6.js\",\"dA1E5\",\"ShareButton.a989ad1a.js\",\"dPqoW\",\"mention.28b46aed.js\",\"1FHbS\",\"mention.runtime.e9c93cad.js\",\"ftJgg\",\"ShareButton.f5289ded.js\",\"j4POW\",\"GroupAndUserItem.05c3b52c.js\",\"1FHbS\",\"mention.runtime.e9c93cad.js\",\"lookM\",\"user-header-for-space-with-guests-Light.1b10bf7d.svg\",\"2GHvs\",\"user-header-for-space-with-guests-Dark.3d8c1f10.svg\",\"ltXeo\",\"PageTree.7e4eaa10.js\",\"dviIw\",\"CollapsibleSection.ed75445b.js\",\"dkv9z\",\"PageTreeAfterIcon.a4527574.js\",\"9F7vX\",\"CreateContentPopover.cce1e01c.js\",\"bAbyV\",\"top-nav.0c4cf158.js\",\"f1WN5\",\"top-nav.ce3a5875.js\",\"7ZpqL\",\"top-nav.d7e98ea8.js\",\"dwffN\",\"GlobalCreateContentPopoverMenu.705150d7.js\",\"kiDFE\",\"CreateSpaceMenuItem.113cb1a5.js\",\"cZgEZ\",\"ContentTreeOnboarding.a956f046.js\",\"6fU2k\",\"drag-handle.399fd7ee.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.1b2a8415.js\",\"3tVyh\",\"CreateSpacePlusButton.09a41ede.js\",\"dLkMK\",\"CommentEditor.3c5dd197.js\",\"np2ZB\",\"NonMasteredUserModal.5f8d033f.js\",\"j2eUy\",\"nonMasteredUserModalSplashImage.90ba8397.svg\",\"hq1Iv\",\"masteringFlowSplashImage.1f9bd0cc.svg\",\"2a8Ft\",\"is-supported.2cc000b0.js\",\"cvmv4\",\"esm.9c824e21.js\",\"lFp1i\",\"FullPageEditorComponent.bf570a47.js\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"jBwbI\",\"LoomMigrationModalManager.1b989e26.js\",\"3jZMP\",\"loomMigrationModalImage.fa8ef03b.svg\",\"1wrZ9\",\"vector.07efb279.svg\",\"014Eq\",\"pageHeaderSpotlightImage.b1e98e59.png\",\"ipnbL\",\"createSpotlightImage.f64dc988.png\",\"2oVPY\",\"ContextualCreateContentPopoverMenu.b789f086.js\",\"hr1db\",\"DatabaseGAOnboarding.fdc4cc79.svg\",\"h4qu8\",\"LiveDocsIntroGif.d2fc0787.gif\",\"j7hKO\",\"LiveDocIntroGADark.45e6357d.svg\",\"7yu5V\",\"LiveDocIntroGALight.8a32f41a.svg\",\"5TJ4V\",\"WhiteboardExperimentSpotlightImage.49c94c1b.svg\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"e9W8R\",\"ContextualCreateContentPopoverMenu.59de57f0.js\",\"iBa9k\",\"ReadTimePopup.46d3f6e6.js\",\"kK8Cc\",\"FullPageEditorComponent.0daa69ff.js\",\"ac6oS\",\"QuickSummaryPopup.21268f5f.js\",\"h7Fyj\",\"quick_summary_spotlight.2a439c01.gif\",\"jrchu\",\"QuickSummaryStreamingEntryPoint.cee5f993.js\",\"kUbT8\",\"AISummaryFooter.875fde2a.js\",\"6qah4\",\"atl.87332ca0.js\",\"emd3r\",\"FullPageEditorComponent.28bc097e.js\",\"kIPUL\",\"cardWithMediaClient.16888cd1.js\",\"7ylp3\",\"cardWithMediaClient.runtime.42fccdf8.js\",\"MrUJ0\",\"modal.f2ecccb6.js\",\"bfM3g\",\"panel.85102082.js\",\"p89La\",\"ReadTime.6ef73312.js\",\"17JTB\",\"modal.ab3296f0.js\",\"cMAQT\",\"DropboxIcon.a8826e5f.js\",\"9n0AM\",\"dropboxscript.62f72250.js\",\"8AwXG\",\"ProjectLinker.38b61151.js\",\"j0KqR\",\"jira-board-light.49fc2d6c.png\",\"aEOsg\",\"jira-board-dark.4f2096de.png\",\"chv15\",\"jira-static-light.fe57e5bd.png\",\"5koHF\",\"jira-static-dark.ec3cbc0d.png\",\"g7QTt\",\"CoreInvites.aa4f9f3f.js\",\"i0gb6\",\"CoreInvites.runtime.e67fa744.js\",\"6Z8WE\",\"en.3315bf41.js\",\"f28kH\",\"16.87120fc0.js\",\"fKONs\",\"16.85a9fe8d.js\",\"8Xuep\",\"16.0725cb87.js\",\"abVVB\",\"16.baea0132.js\",\"hlqS1\",\"16.9935b550.js\",\"c0JsV\",\"link-picker.03edd451.js\",\"gYKCE\",\"media-viewer-error-boundary.54d19232.js\",\"gQSWJ\",\"chevron-right.63dc8531.js\",\"dBjkU\",\"add.25715708.js\",\"avCUM\",\"chevron-left.d78b2f60.js\",\"5K06i\",\"modal.a8739d91.js\",\"jCu7l\",\"FullPageEditorComponent.b88a755d.js\",\"2HlAY\",\"root-component.e599dff3.js\",\"i0gb6\",\"CoreInvites.runtime.e67fa744.js\",\"hXu5I\",\"plussquare.b31ea70a.js\",\"kkycx\",\"issue-raise.6fdf5e25.js\",\"7lyIx\",\"page.d018348a.js\",\"esvqD\",\"page.e19a2d78.js\",\"a0oMZ\",\"ui.62903b58.js\",\"i1TuF\",\"cs.2190cb07.js\",\"eEPT4\",\"da.02eaca38.js\",\"gkfGT\",\"de.90355bf8.js\",\"6kSRw\",\"en.32193a4b.js\",\"2dFTF\",\"en_GB.09598cb2.js\",\"auo6z\",\"en_ZZ.f14ca7c2.js\",\"685rk\",\"es.8fa0593c.js\",\"fp6pG\",\"fi.71fd59df.js\",\"6bt8l\",\"fr.40c5717d.js\",\"jjvsl\",\"hu.50ccd7da.js\",\"bAfbH\",\"it.e0e7a6ba.js\",\"5Q9X0\",\"ja.2dfec41f.js\",\"ePkyJ\",\"ko.0b1ec89d.js\",\"hpdFn\",\"nb.b2e768d2.js\",\"8qW90\",\"nl.7f781ad8.js\",\"a1OSV\",\"pl.ca25a045.js\",\"8AvOI\",\"pt_BR.eb536358.js\",\"jxu37\",\"ru.3bbb4cd9.js\",\"10YQF\",\"sv.b02b2c4a.js\",\"daBgp\",\"tr.1172519d.js\",\"bI6N0\",\"th.b72c3249.js\",\"3Qhls\",\"uk.c5a9160e.js\",\"dgXIC\",\"vi.98dce50e.js\",\"jh4hi\",\"zh_TW.79a7157d.js\",\"2AL0H\",\"zh.29b1c23a.js\",\"iaptT\",\"Page.0b949bdb.js\",\"kG8pF\",\"ViewPage.7d406f94.js\",\"jSPit\",\"ViewPage.5d7bd249.js\",\"4YF8c\",\"EditPage.993dca19.js\",\"lPCqB\",\"FullPageEditorComponent.b1011b8a.js\",\"gGI57\",\"Page.43016ef1.js\",\"8ulXC\",\"FullPageEditorComponent.73b9623f.js\",\"anP9P\",\"error.5fbc7fe9.png\",\"i5uoM\",\"modal.5af59394.js\",\"7KgfJ\",\"cardWithMediaClient.229d12a7.js\",\"5SiDe\",\"modal.47de2a2c.js\",\"kO0mz\",\"audio-icon.3fb3ee2d.js\",\"jDjSj\",\"16.8a4cce0e.js\",\"gQLjx\",\"angle-brackets-icon.23aea32b.js\",\"3wmvj\",\"16.b741d755.js\",\"jWyan\",\"angle-brackets-icon.0108617d.js\",\"5i5pX\",\"folder-icon.44372aa8.js\",\"eA5B3\",\"image-icon.cd228769.js\",\"8059b\",\"16.afe6487f.js\",\"7AsyI\",\"video-icon.71c49a3b.js\",\"hPalR\",\"16.93dce164.js\",\"8LPnw\",\"lock-locked--lock-filled.311149cb.js\",\"2fk6g\",\"16.bea78523.js\",\"dil5i\",\"24.e2acaae5.js\",\"huUvS\",\"16.ec1fe873.js\",\"P5iE2\",\"24.874d8c90.js\",\"1oiJ6\",\"16.b49b338d.js\",\"42vdC\",\"24.8676303a.js\",\"lxiFd\",\"16.80951c67.js\",\"9Bu2S\",\"24.1eba1b1c.js\",\"eDqo1\",\"16.f4617b7e.js\",\"8pE8S\",\"24.4b97cbb2.js\",\"6HBYC\",\"16.64a21052.js\",\"ivQYH\",\"24.272a2b94.js\",\"bYxCZ\",\"16.aa8224a8.js\",\"7a9CL\",\"24.f46d75b2.js\",\"eTBsW\",\"16.fd6383aa.js\",\"8mzoy\",\"24.b3fbae03.js\",\"020xd\",\"16.f33a251e.js\",\"bjzRn\",\"24.95103356.js\",\"ls0Um\",\"16.0d741008.js\",\"fYi1a\",\"24.8dbe60cd.js\",\"eVYW1\",\"16.fd806601.js\",\"fqrMn\",\"24.a62bdaeb.js\",\"f35QR\",\"16.b6568c92.js\",\"hzK1f\",\"24.98083536.js\",\"4sSyn\",\"24.aa38ac65.js\",\"dnrR3\",\"24.96022979.js\",\"gxkp2\",\"24.c8cd3e14.js\",\"hiqrg\",\"24.09472e1b.js\",\"490Jr\",\"24.149eb8b7.js\",\"ggkqU\",\"24.890d556e.js\",\"65smn\",\"24.580531d4.js\",\"1fh7t\",\"24.fa918456.js\",\"4mLGd\",\"24.f7631f04.js\",\"cMlHc\",\"24.27cf5eea.js\",\"lSzlP\",\"24.60b95a67.js\",\"5erPe\",\"24.63382dcc.js\",\"cXodu\",\"24.78cf490b.js\",\"4j0Ap\",\"confluence-icon.394c835e.js\",\"87j6O\",\"jira-icon.eb7336b7.js\",\"3vYMs\",\"attachment.7777c63a.js\",\"8PsNg\",\"attachment.f9a06f8f.js\",\"9UmxH\",\"task.44180bef.js\",\"d1W0Z\",\"task.bbe0897b.js\",\"hlgZa\",\"component.7f613fb8.js\",\"aQnhg\",\"component.a0c10401.js\",\"acQiP\",\"comment.8a140e14.js\",\"jSJrn\",\"eye-open--watch.54d1d960.js\",\"jaTPo\",\"watch.5c4b5bd8.js\",\"kgJcP\",\"thumbs-up--like.0d91b8c9.js\",\"dkV2T\",\"like.d696faec.js\",\"513ba\",\"arrow-up.c17a9d66.js\",\"9f4oR\",\"arrow-up.94369a38.js\",\"kefuj\",\"priority-blocker.d8096123.js\",\"bWqqo\",\"priority-critical.c242bf7a.js\",\"9ZeC1\",\"priority-high.3eb9ac43.js\",\"9zpNb\",\"priority-highest.0e78632a.js\",\"gOpe6\",\"priority-low.21ac1cc4.js\",\"RAL03\",\"priority-lowest.535dc7b3.js\",\"5nQIT\",\"priority-major.94eb9450.js\",\"l9frT\",\"priority-medium.3a2d978a.js\",\"lACXG\",\"priority-minor.d2ac136e.js\",\"ao5oO\",\"priority-trivial.965f2280.js\",\"7owaE\",\"question-circle--question.ad7d48ae.js\",\"9PQvE\",\"angle-brackets--code.229a6e25.js\",\"9DPul\",\"code.657e8fdd.js\",\"9FBaW\",\"people-group--people.45cbf20f.js\",\"9dfxa\",\"subtasks--subtask.85d82f30.js\",\"hl2oi\",\"subtask.67cec23f.js\",\"3wY4G\",\"goal-icon.c8c90c26.js\",\"88r9N\",\"projects-icon.c26711c5.js\",\"cqZpg\",\"manual-triggers-modal.27ed1190.js\",\"aoU9B\",\"RelatedLinksModal.87b84dda.js\",\"kDLrp\",\"EmbedModal.1a947c77.js\",\"cXPC0\",\"EmbedModal.0a0dbc0f.js\",\"dUKeO\",\"vid-full-screen-on.89bfbdcb.js\",\"iiqDR\",\"vid-full-screen-off.edfa2cde.js\",\"i4cia\",\"component-lazy.4fe2ce24.js\",\"cMkgU\",\"16.51bd8726.js\",\"kDqHr\",\"file-icon.17cd3207.js\",\"icyPI\",\"document-filled.4b826be1.js\",\"4HZlX\",\"chart-bar-icon.16584d67.js\",\"7jSfd\",\"list-bullet-icon.ed312ec4.js\",\"4x0L6\",\"people-group.e7ed4330.js\",\"bZO0a\",\"people-group.b7831300.js\",\"k6H7B\",\"file--document-filled.9932b544.js\",\"7OtNC\",\"16.25d5434d.js\",\"dzfxi\",\"16.77d0f410.js\",\"47wm8\",\"16.ae36793b.js\",\"j2OLf\",\"16.20dd34be.js\",\"3c6qD\",\"16.fb87f4ed.js\",\"b1gz4\",\"16.0dfc6cf6.js\",\"l42ar\",\"16.4131b2cf.js\",\"i8IR3\",\"lock.20202240.js\",\"8KDBK\",\"inline-create-one-step-experiment.c2c056f4.js\",\"6XNSn\",\"codeBlockAdvanced.803af87a.js\",\"6qRJw\",\"dist.a90fea49.js\",\"1EgQg\",\"dist.7c7ec582.js\",\"jneCP\",\"dist.adf4c603.js\",\"lLY5F\",\"dist.521fa1db.js\",\"7sleH\",\"dist.21a5cb52.js\",\"gkT8b\",\"dist.11d30e66.js\",\"1Wolg\",\"dist.b936756b.js\",\"fNNWn\",\"dist.e67d127a.js\",\"93dCk\",\"codeViewer.71b6c0bb.js\",\"01BDc\",\"dist.f36f7d00.js\",\"3lBx7\",\"dist.82105929.js\",\"iWiJK\",\"dist.03768f8e.js\",\"7BCTg\",\"dist.daadd8cb.js\",\"jD4Pj\",\"dist.0c350558.js\",\"217bQ\",\"dist.563e7eec.js\",\"3AIgh\",\"dist.a75fea7a.js\",\"3WBDc\",\"dist.b344a93f.js\",\"gnPOt\",\"dist.761f9dfc.js\",\"73p2H\",\"dist.0397e21f.js\",\"22pEl\",\"dist.8b39c40c.js\",\"cgrQ3\",\"dist.a04ab887.js\",\"5BOC6\",\"dist.30663d49.js\",\"b3fvV\",\"dist.37416658.js\",\"ajqM4\",\"dist.9ab582a8.js\",\"jjPUS\",\"apl.b81e50f9.js\",\"h9FOd\",\"asciiarmor.8042d41d.js\",\"aCljb\",\"asn1.a9aaf8f7.js\",\"lE1F7\",\"asterisk.f4595367.js\",\"aXFnX\",\"brainfuck.4bd8ce2f.js\",\"gkO56\",\"cobol.30d0d372.js\",\"aXQyM\",\"clike.34bb1d46.js\",\"diAFJ\",\"clojure.21077391.js\",\"d7yTx\",\"css.3d1ff96e.js\",\"b2YDT\",\"cmake.0e3e455b.js\",\"4ga7U\",\"coffeescript.c2281a85.js\",\"cZ3D7\",\"commonlisp.97a06575.js\",\"qaaCs\",\"cypher.b80fd281.js\",\"9Fcz0\",\"python.f5111821.js\",\"6RZjl\",\"crystal.a0197265.js\",\"ji1Kk\",\"d.42c2683e.js\",\"2L5Mz\",\"diff.cdb11d67.js\",\"lmz4e\",\"dockerfile.70f43558.js\",\"814bh\",\"dtd.11778cc2.js\",\"7XVNh\",\"dylan.468e767f.js\",\"hGS6V\",\"ebnf.30d80091.js\",\"592ir\",\"ecl.5a273c1a.js\",\"hPiIc\",\"eiffel.85a912d8.js\",\"7wfVk\",\"elm.77c03e04.js\",\"ebMo8\",\"erlang.6dc9b335.js\",\"5h0BU\",\"sql.83903d9f.js\",\"bE4uu\",\"factor.91d4bca2.js\",\"7Mgt2\",\"fcl.8ab4c522.js\",\"bOI1J\",\"forth.3c528cb4.js\",\"bmWQh\",\"fortran.e0029ed4.js\",\"kHxTh\",\"mllike.153cf519.js\",\"6MC1n\",\"gas.a7bccbc7.js\",\"lNBbh\",\"gherkin.3957c5fc.js\",\"bYMjO\",\"groovy.2c7c6877.js\",\"kIBZl\",\"haskell.27501ac4.js\",\"3uMSv\",\"haxe.54a5898e.js\",\"9vuGq\",\"http.bc2057b4.js\",\"1eHix\",\"idl.b9661b63.js\",\"7kn4A\",\"javascript.398b6ea8.js\",\"j4qEZ\",\"jinja2.a602283d.js\",\"3ozoR\",\"julia.eb339e67.js\",\"3DTzS\",\"livescript.a061dc12.js\",\"hURlP\",\"lua.1771bd2a.js\",\"2gQjS\",\"mirc.df514b63.js\",\"hoU9b\",\"mathematica.4b8aab4c.js\",\"40pAI\",\"modelica.f8eb4cea.js\",\"i5YKF\",\"mumps.cf82c6f0.js\",\"hIeWi\",\"mbox.e4169567.js\",\"8q3KK\",\"nginx.5d266b03.js\",\"1VXLT\",\"nsis.e4e191fa.js\",\"bAq00\",\"ntriples.12b53fef.js\",\"aEtpl\",\"octave.05b71169.js\",\"hfTKk\",\"oz.0938f362.js\",\"hTqBJ\",\"pascal.39d89476.js\",\"5ukWe\",\"perl.52765d5b.js\",\"3XLd5\",\"pig.0fb008c2.js\",\"2QavN\",\"powershell.f53ac67c.js\",\"ch01A\",\"properties.ff60ea69.js\",\"7inaT\",\"protobuf.c983d409.js\",\"cJ7mc\",\"pug.9abece4a.js\",\"5NvMz\",\"puppet.b9ab89df.js\",\"ego66\",\"q.aaa15180.js\",\"hj2Rh\",\"r.0b08b779.js\",\"b7tzx\",\"rpm.685318b2.js\",\"3YkAH\",\"ruby.04bb2af8.js\",\"cf92i\",\"sas.9ff0311d.js\",\"8W2eu\",\"scheme.a36ef94c.js\",\"lcrbq\",\"shell.d5f15f17.js\",\"98Pr8\",\"sieve.f0f2cb2c.js\",\"9dDWH\",\"smalltalk.33729233.js\",\"lrUqt\",\"solr.21ea773c.js\",\"bfOqz\",\"sparql.554ff633.js\",\"glXdM\",\"spreadsheet.cd8b4101.js\",\"b9USS\",\"stylus.7e0a4e39.js\",\"kPthK\",\"swift.633d1fa8.js\",\"jsCJL\",\"stex.8d5212f6.js\",\"abYjx\",\"verilog.d22265d7.js\",\"d7Hao\",\"tcl.ced1f258.js\",\"axn6R\",\"textile.51355a0b.js\",\"jDwZc\",\"tiddlywiki.5e83d78f.js\",\"ejPOn\",\"tiki.6fb365f5.js\",\"jx5LN\",\"toml.84dc3c91.js\",\"lsrGy\",\"troff.f7dd2860.js\",\"caKW9\",\"ttcn.4a33ec37.js\",\"6cyuP\",\"ttcn-cfg.5ae2f58f.js\",\"kezEf\",\"turtle.ed16c466.js\",\"ec2k9\",\"webidl.32e06ad6.js\",\"gQivI\",\"vb.278bc558.js\",\"1MGG6\",\"vbscript.a342aecd.js\",\"19BgE\",\"velocity.40adbcac.js\",\"4QVhK\",\"vhdl.7cdb96b8.js\",\"5PTeQ\",\"xquery.27819ab6.js\",\"7rV3v\",\"yacas.6d63ee7e.js\",\"lzeGI\",\"z80.2e6d4d2e.js\",\"jZHIh\",\"mscgen.5ea5176c.js\",\"hLKFT\",\"dist.a9b48aa5.js\",\"4ZwHa\",\"dist.83c91e9c.js\",\"dnE79\",\"editor-ai-opt-in-banner.523b2454.svg\",\"6z3SN\",\"BrowseRovoAgentsModal.6e71acd0.js\",\"3xznI\",\"search.0780a38a.js\",\"d2yzT\",\"AgentProfileCard.c305ab5a.js\",\"erM4f\",\"star-filled.1f795fb2.js\",\"6FSEq\",\"star.e20ad96e.js\",\"g2v3v\",\"BrowseRovoAgentsModal.def89e43.js\",\"g7pmM\",\"suitcase.3354a23a.js\",\"7ylp3\",\"cardWithMediaClient.runtime.42fccdf8.js\",\"cCo7G\",\"cs.1990b7aa.js\",\"2yaNi\",\"da.a8b3e286.js\",\"1bqZ7\",\"de.2ecfcecb.js\",\"dtcDt\",\"en_GB.3327ebf6.js\",\"bbNMp\",\"en.3c1c8377.js\",\"jmeku\",\"en_ZZ.33c975a9.js\",\"gvu1P\",\"es.f9ddf840.js\",\"77OtH\",\"fi.82764f00.js\",\"kwpyS\",\"fr.026f878e.js\",\"jR65k\",\"hu.45a5801e.js\",\"hjKsx\",\"it.c62a7adf.js\",\"7SU8v\",\"ja.de33cd16.js\",\"6CkyE\",\"ko.b651f3f7.js\",\"9jxAI\",\"nb.7760e080.js\",\"gipQq\",\"nl.b8add44b.js\",\"lGaKH\",\"pl.091829d1.js\",\"cnozD\",\"pt_BR.7830f082.js\",\"576vh\",\"ru.bd7ad7e5.js\",\"6TNAX\",\"sv.dc533dc0.js\",\"7DeyD\",\"tr.eb8480f5.js\",\"hshW4\",\"th.2ec6b0ff.js\",\"lqXcv\",\"uk.286130b8.js\",\"fTQUk\",\"vi.6b1e9844.js\",\"hqXjy\",\"zh_TW.654e13e7.js\",\"5DEnz\",\"zh.38cc7b68.js\",\"4kOrv\",\"SaveCompanyHubConfirmationModal.6957e1cc.js\",\"N69Ko\",\"PreviewBanner.6705398a.svg\",\"lffTV\",\"PreviewBanner-dark.692d372a.svg\",\"3Kg3S\",\"CreateComponent.108664c1.js\",\"dGk3x\",\"GlobalFeedbackCollector.28adcc39.js\",\"cyGuT\",\"feedback-collector.60707fec.js\",\"aZinD\",\"vendors.d807c867.js\",\"c6MKV\",\"stable_vendors.c60294fd.js\",\"56uR7\",\"GlobalFeedbackCollector.d3a8ea09.js\",\"1RolH\",\"EmojiPickerComponent.11a72e32.js\",\"1sEV4\",\"objects.828d82d3.js\",\"cUIjD\",\"frequent.1f0dffc7.js\",\"6j8nK\",\"symbols.fdc6ed64.js\",\"l4q1r\",\"FullPageEditorComponent.74890770.js\",\"6Tafs\",\"people.dbf024a3.js\",\"etwBB\",\"activity.d3402161.js\",\"a2rZD\",\"custom.b28554c7.js\",\"4yJnq\",\"add.c7dd6669.js\",\"ePm95\",\"flags.40431f78.js\",\"kJcWg\",\"food.473b199a.js\",\"4tIwu\",\"nature.96f73db7.js\",\"i1sL7\",\"travel.5460db1e.js\",\"36ctu\",\"productivity.0d33ec61.js\",\"LVlMG\",\"modal.4fdcc75f.js\",\"5doAZ\",\"DatePicker.c6742099.js\",\"aTvLE\",\"modal.b7389c27.js\",\"6aruy\",\"media-client-react.88ecf091.js\",\"fsZ6i\",\"media-client-react.9f5d735a.js\",\"7VwsU\",\"media-client-react.runtime.67e523fd.js\",\"7VwsU\",\"media-client-react.runtime.67e523fd.js\",\"9KJWc\",\"clipboard.256435a8.js\",\"1qUWs\",\"media-viewer-error-boundary.445b2080.js\",\"7Vmxp\",\"table.f8779bf1.js\",\"fwuXj\",\"cardWithMediaClient.b8c2ff5f.js\",\"8Ozg8\",\"inlinePlayer.e8efc062.js\",\"6StWh\",\"modal.ea9cec89.js\",\"5rLJa\",\"vid-pause.b74a9dab.js\",\"jPg5M\",\"LinkCards.44801c8c.js\",\"6dDCB\",\"outgoing-sound.ec5fde53.js\",\"gn6fp\",\"video.054f8ea8.js\",\"kUAIU\",\"more.9db3674e.js\",\"3ooAX\",\"download.4d27b891.js\",\"e53Dv\",\"vid-play.9e8ddef6.js\",\"6gqpV\",\"GlobalFeedbackCollector.493c1808.js\",\"7ZMdq\",\"modal.393a4288.js\",\"4M7W5\",\"mediaInlineCard.11bd096a.js\",\"iP5Bv\",\"mediaInlineAnalyticsErrorBoundary.da71b2bb.js\",\"9p2N9\",\"ui.4887783c.js\",\"h9hWQ\",\"SimpleEmoji.0213c7c9.js\",\"eFHVS\",\"extensibility.bc55036e.js\",\"djfev\",\"ConfigPanelFieldsLoader.5cca2bc4.js\",\"7ofLD\",\"modal.cf3a2c28.js\",\"6nr9L\",\"modal.runtime.c2d6c732.js\",\"eoIpr\",\"add-circle.203cd6d7.js\",\"jgfeV\",\"HelpPanel.5abdba49.js\",\"cOBj9\",\"HelpPanel.runtime.d201d323.js\",\"6nr9L\",\"modal.runtime.c2d6c732.js\",\"cOBj9\",\"HelpPanel.runtime.d201d323.js\",\"cKkZK\",\"media-viewer-error-boundary.ad68b1d0.js\",\"bHwQq\",\"archive.65124313.js\",\"9vSeI\",\"audio.7b721c3b.js\",\"8PuzS\",\"archive.29f79635.js\",\"lixGB\",\"78-EUC-H.51d0c3f9.js\",\"fH2pk\",\"78-EUC-V.64ff1cfd.js\",\"kZB45\",\"78-H.0ed13b16.js\",\"6BxSI\",\"78-RKSJ-H.dc86b34e.js\",\"i9zPw\",\"78-RKSJ-V.82830549.js\",\"8Qq8X\",\"78-V.b650b3b6.js\",\"hUHQJ\",\"78ms-RKSJ-H.8d99de38.js\",\"4Y4SR\",\"78ms-RKSJ-V.d9f17393.js\",\"axQaS\",\"83pv-RKSJ-H.f8767ab6.js\",\"hh6Ks\",\"90ms-RKSJ-H.d832d6a6.js\",\"gyPUO\",\"90ms-RKSJ-V.260dbffb.js\",\"aduQJ\",\"90msp-RKSJ-H.364f2808.js\",\"3iFld\",\"90msp-RKSJ-V.aa85de80.js\",\"6XUCn\",\"90pv-RKSJ-H.848d9bac.js\",\"8eJG6\",\"90pv-RKSJ-V.92513b15.js\",\"iveJ5\",\"Add-H.729159c7.js\",\"kOqxj\",\"Add-RKSJ-H.2baf4c23.js\",\"1zYOj\",\"Add-RKSJ-V.24c188d0.js\",\"2MU2T\",\"Add-V.f276585e.js\",\"oH9eX\",\"Adobe-CNS1-0.c94fb46d.js\",\"fSa6m\",\"Adobe-CNS1-1.22c8a053.js\",\"g2oEO\",\"Adobe-CNS1-2.b6e41c65.js\",\"8WzHR\",\"Adobe-CNS1-3.6168987e.js\",\"ca0bh\",\"Adobe-CNS1-4.44238a8c.js\",\"cfcpu\",\"Adobe-CNS1-5.62d26997.js\",\"li5lK\",\"Adobe-CNS1-6.7ebee211.js\",\"kujwR\",\"Adobe-CNS1-UCS2.0dd5c8ce.js\",\"8iFzj\",\"Adobe-GB1-0.249f5de6.js\",\"6D5co\",\"Adobe-GB1-1.74dabbbf.js\",\"cfFSd\",\"Adobe-GB1-2.4a68d0c8.js\",\"exff1\",\"Adobe-GB1-3.b5b05f5d.js\",\"aeuVs\",\"Adobe-GB1-4.c9dd9584.js\",\"aLrjO\",\"Adobe-GB1-5.0e92a2eb.js\",\"j3PYN\",\"Adobe-GB1-UCS2.bb70ebea.js\",\"d0uYO\",\"Adobe-Japan1-0.4d890a6e.js\",\"eEcvV\",\"Adobe-Japan1-1.a0781bed.js\",\"820v9\",\"Adobe-Japan1-2.9f2dc797.js\",\"frVgA\",\"Adobe-Japan1-3.15951cff.js\",\"jdQzX\",\"Adobe-Japan1-4.0cfae895.js\",\"Z8yoS\",\"Adobe-Japan1-5.66dd1b5b.js\",\"k2vqy\",\"Adobe-Japan1-6.7e06fceb.js\",\"kgt4y\",\"Adobe-Japan1-UCS2.e121ba74.js\",\"eP0RM\",\"Adobe-Korea1-0.ab6029ff.js\",\"gA5f7\",\"Adobe-Korea1-1.f58d7af7.js\",\"i4Ed8\",\"Adobe-Korea1-2.90e46d21.js\",\"l6X7m\",\"Adobe-Korea1-UCS2.37651d5b.js\",\"aphLF\",\"B5-H.35e26a2d.js\",\"7EoeH\",\"B5-V.af3f0204.js\",\"6Q7ZY\",\"B5pc-H.e4f1d7a8.js\",\"8cnq9\",\"B5pc-V.8f5377c3.js\",\"7NcV5\",\"CNS-EUC-H.6bb831b5.js\",\"cxpt9\",\"CNS-EUC-V.8c378414.js\",\"l27ve\",\"CNS1-H.ea7d046f.js\",\"c6rCW\",\"CNS1-V.1fdf3e4e.js\",\"3upsV\",\"CNS2-H.705fd9e8.js\",\"k9G9k\",\"CNS2-V.c55f4d63.js\",\"bDgpL\",\"ETHK-B5-H.7f8e45d5.js\",\"33eqd\",\"ETHK-B5-V.09bf3c22.js\",\"5F3PA\",\"ETen-B5-H.05fb1408.js\",\"hfiT2\",\"ETen-B5-V.5e380c42.js\",\"jMuj8\",\"ETenms-B5-H.3891364b.js\",\"gNTCu\",\"ETenms-B5-V.394705ca.js\",\"6rTQb\",\"EUC-H.b991c232.js\",\"l89SH\",\"EUC-V.0ac4677e.js\",\"iEkij\",\"Ext-H.5968bae5.js\",\"eVVKx\",\"Ext-RKSJ-H.d9938a5e.js\",\"kL3q4\",\"Ext-RKSJ-V.e9a51cbe.js\",\"avDfo\",\"Ext-V.74d1f996.js\",\"l3LgN\",\"GB-EUC-H.910bba6d.js\",\"eIBS8\",\"GB-EUC-V.0c6edfac.js\",\"8HXb3\",\"GB-H.92bed904.js\",\"lWK2A\",\"GB-V.4564569a.js\",\"iYIwI\",\"GBK-EUC-H.f5f68a8f.js\",\"g4Lp1\",\"GBK-EUC-V.97682197.js\",\"9jlRI\",\"GBK2K-H.edc4a051.js\",\"g2IgM\",\"GBK2K-V.46c62554.js\",\"24SBU\",\"GBKp-EUC-H.da565c58.js\",\"gzU5W\",\"GBKp-EUC-V.d5927fe2.js\",\"jN4tb\",\"GBT-EUC-H.267ac8c0.js\",\"6fVUl\",\"GBT-EUC-V.7720b25f.js\",\"e0AMV\",\"GBT-H.974fe797.js\",\"htjXf\",\"GBT-V.12defd7a.js\",\"hWeIU\",\"GBTpc-EUC-H.43d524d7.js\",\"1eaMl\",\"GBTpc-EUC-V.c77ba0fc.js\",\"fDvqM\",\"GBpc-EUC-H.08408830.js\",\"2de5A\",\"GBpc-EUC-V.ddbe12a3.js\",\"19tEv\",\"H.8a76eaa0.js\",\"j0hRA\",\"HKdla-B5-H.e6a4bedb.js\",\"fd9qd\",\"HKdla-B5-V.94816590.js\",\"e9cdN\",\"HKdlb-B5-H.41238054.js\",\"aNHZK\",\"HKdlb-B5-V.c7a56f0d.js\",\"hgC4a\",\"HKgccs-B5-H.423aefeb.js\",\"eEaBv\",\"HKgccs-B5-V.fff775c8.js\",\"fYV0G\",\"HKm314-B5-H.60d4b9bb.js\",\"dJs80\",\"HKm314-B5-V.997bace9.js\",\"4Y1kq\",\"HKm471-B5-H.0a6f2053.js\",\"hYpsA\",\"HKm471-B5-V.5588cb3b.js\",\"9xkOt\",\"HKscs-B5-H.cbf6db19.js\",\"lm69C\",\"HKscs-B5-V.cf9a31dc.js\",\"kva4v\",\"Hankaku.ca0ba78b.js\",\"5AfTB\",\"Hiragana.85378b4a.js\",\"3TaY6\",\"KSC-EUC-H.aff5022e.js\",\"8wf7j\",\"KSC-EUC-V.3949c72d.js\",\"cgHyF\",\"KSC-H.4ed431c9.js\",\"cxq0E\",\"KSC-Johab-H.22d6dfec.js\",\"ipw37\",\"KSC-Johab-V.0ee59f70.js\",\"aD76K\",\"KSC-V.dc2b8859.js\",\"8okaY\",\"KSCms-UHC-H.b54f6070.js\",\"i7fxp\",\"KSCms-UHC-HW-H.998acbf6.js\",\"7fYMC\",\"KSCms-UHC-HW-V.0a3c59db.js\",\"imOx6\",\"KSCms-UHC-V.37c6be44.js\",\"gKF8I\",\"KSCpc-EUC-H.4cfc83d8.js\",\"9m5PS\",\"KSCpc-EUC-V.5881e143.js\",\"8asvD\",\"Katakana.321c2f5f.js\",\"7HkN3\",\"NWP-H.6a69fa60.js\",\"isnju\",\"NWP-V.88613bd5.js\",\"f31m2\",\"RKSJ-H.2af2abd8.js\",\"2VYvR\",\"RKSJ-V.65a07798.js\",\"1KF3Q\",\"Roman.ca13d8f3.js\",\"29QIq\",\"UniCNS-UCS2-H.f2596cac.js\",\"dVqyh\",\"UniCNS-UCS2-V.4be9430a.js\",\"7UKDA\",\"UniCNS-UTF16-H.bb71adc5.js\",\"Q9KG4\",\"UniCNS-UTF16-V.d89c4950.js\",\"c2z6B\",\"UniCNS-UTF32-H.6ef36f87.js\",\"lTznr\",\"UniCNS-UTF32-V.c838593e.js\",\"7t7V6\",\"UniCNS-UTF8-H.77d5771f.js\",\"lcMXU\",\"UniCNS-UTF8-V.70a7ba9f.js\",\"4Y11P\",\"UniGB-UCS2-H.1303e3c8.js\",\"6MnqR\",\"UniGB-UCS2-V.c4668ab1.js\",\"eQt1R\",\"UniGB-UTF16-H.d1be3be2.js\",\"fm8Lw\",\"UniGB-UTF16-V.a072ba07.js\",\"4l8L7\",\"UniGB-UTF32-H.e2d1c79f.js\",\"1tDis\",\"UniGB-UTF32-V.76c200be.js\",\"2Vv5T\",\"UniGB-UTF8-H.41f4baba.js\",\"iWa77\",\"UniGB-UTF8-V.8ed42052.js\",\"38Eab\",\"UniJIS-UCS2-H.e0c99f94.js\",\"lDeVy\",\"UniJIS-UCS2-HW-H.2086623a.js\",\"8aWy7\",\"UniJIS-UCS2-HW-V.ffb2caeb.js\",\"76QHL\",\"UniJIS-UCS2-V.21ffe4a5.js\",\"lRW10\",\"UniJIS-UTF16-H.4216604d.js\",\"aJpvy\",\"UniJIS-UTF16-V.48b4e738.js\",\"7s6rx\",\"UniJIS-UTF32-H.038159ea.js\",\"jUs4H\",\"UniJIS-UTF32-V.34681c47.js\",\"a8YIF\",\"UniJIS-UTF8-H.3f187918.js\",\"fH9Jk\",\"UniJIS-UTF8-V.dd6be6a0.js\",\"13MuZ\",\"UniJIS2004-UTF16-H.c4a60299.js\",\"hwfXT\",\"UniJIS2004-UTF16-V.2dbaf4f4.js\",\"dGSeC\",\"UniJIS2004-UTF32-H.dba66596.js\",\"9rrYA\",\"UniJIS2004-UTF32-V.74761cad.js\",\"7d1OI\",\"UniJIS2004-UTF8-H.4ec8549f.js\",\"809oM\",\"UniJIS2004-UTF8-V.c5cc5b20.js\",\"bdrR8\",\"UniJISPro-UCS2-HW-V.4031e777.js\",\"4D2EW\",\"UniJISPro-UCS2-V.5072efde.js\",\"cdY8a\",\"UniJISPro-UTF8-V.7adee45d.js\",\"avqzB\",\"UniJISX0213-UTF32-H.56363b94.js\",\"j845q\",\"UniJISX0213-UTF32-V.6e415ebf.js\",\"emImx\",\"UniJISX02132004-UTF32-H.80a3d411.js\",\"f6AOW\",\"UniJISX02132004-UTF32-V.75e044a9.js\",\"7pSug\",\"UniKS-UCS2-H.4ff5f169.js\",\"465mT\",\"UniKS-UCS2-V.af99e23d.js\",\"3w6Hd\",\"UniKS-UTF16-H.b031c3f9.js\",\"4T3rW\",\"UniKS-UTF16-V.dbaec3f8.js\",\"d8Hqs\",\"UniKS-UTF32-H.11f34035.js\",\"77ADK\",\"UniKS-UTF32-V.344d4ef0.js\",\"dkDCu\",\"UniKS-UTF8-H.a4bf67c4.js\",\"8Qdf7\",\"UniKS-UTF8-V.af9521f3.js\",\"bhNwf\",\"V.5ce814bb.js\",\"ioEN1\",\"WP-Symbol.9e3226a6.js\",\"hGXAt\",\"arrow-left.ed8cca79.js\",\"edP6u\",\"home.9c6d2e67.js\",\"2OhRQ\",\"codeViewerRenderer.29c899a3.js\",\"3wpjh\",\"image.4dcab477.js\",\"869mA\",\"video.ed5921aa.js\",\"j7Vtd\",\"audio.ca524548.js\",\"f33Ay\",\"doc.e5ab981a.js\",\"2JEgu\",\"codeViewer.50fd71a1.js\",\"gQYJt\",\"svg.0f44db18.js\",\"gFHfi\",\"zoom-out.db09cd7a.js\",\"4uhcp\",\"zoom-in.5852ad10.js\",\"doomh\",\"chevron-left-circle.db11b726.js\",\"lnWRh\",\"chevron-right-circle.2430a910.js\",\"cCWZm\",\"dropzone.a0930126.js\",\"lE3cg\",\"media-picker-analytics-error-boundary.522e0176.js\",\"bbnaa\",\"GlobalFeedbackCollector.52f86c02.js\",\"8Khwy\",\"GlobalFeedbackCollector.7c1b47d5.js\",\"lKaDG\",\"ProfileCard.9660069c.js\",\"gcxqu\",\"ProfileCard.runtime.ea2d8158.js\",\"ePOyH\",\"ShareButton.18b987f2.js\",\"kpHRm\",\"GeneralShortcutListener.744314f2.js\",\"dH2J7\",\"CreateComponent.90503677.js\",\"3Ha0P\",\"FullPageEditorComponent.4b3918c5.js\",\"aHCaB\",\"ViewComponent.1fac4968.js\",\"bCr24\",\"main.4a493781.js\",\"lp0cK\",\"both-splash.465c87c4.svg\",\"bo7LK\",\"teams-splash.36cc0781.svg\",\"8XHrw\",\"slack-splash.73e116f6.svg\",\"1TOYq\",\"CoreInvites.0dca447d.js\",\"gcxqu\",\"ProfileCard.runtime.ea2d8158.js\",\"hpN5y\",\"ForgeAction.54b5680e.js\",\"eM4KW\",\"TextHighlighter.760e4f55.js\",\"bGzhS\",\"ByLineForgeApp.a9209aa3.js\",\"jeyta\",\"no-results.603cf20f.svg\",\"g9CVe\",\"mention.28df720c.js\",\"gwAWX\",\"modal.4b126b0d.js\",\"daCl8\",\"RendererContentStateWithSpotlight.e6cad317.js\",\"9L8th\",\"PageContentRendererFabric.05079866.js\",\"iQ0Jm\",\"SmartButtonConfigPanel.8bd6321a.js\",\"2aE9V\",\"UnarchivePagesLoader.f931446c.js\",\"khV58\",\"PageSelectionTable.d502a7c6.js\",\"in6Mc\",\"NoChildrenBullet.077cc505.js\",\"bm3DR\",\"EmptyPageSelectionTable.f436bd81.js\",\"5IFtr\",\"fileCabinet.8e8cc872.svg\",\"2HL52\",\"QuickActionMenuBase.c928ec47.js\",\"awXdT\",\"error.b6351f9e.svg\",\"aOpoD\",\"empty-automation-list.9c7d0496.png\",\"lnKog\",\"main.885905c1.js\",\"bEOWq\",\"FullPageEditorComponent.b8d3b1d4.js\",\"hf7yW\",\"ByLineForgeApp.1de39abd.js\",\"cjJTJ\",\"section-message.542a51ad.js\",\"bf0yj\",\"modal-dialog.468b4265.js\",\"eMbal\",\"loading-button.90d63bac.js\",\"1kb22\",\"LabelsSelect.bbdd72fe.js\",\"a7qwF\",\"LabelsSelectErrors.e6b3fe39.js\",\"bdzih\",\"ContentActionForgeApp.d5028280.js\",\"cwpVK\",\"ContextMenuForgeApp.f739bfe8.js\",\"87cDu\",\"GlobalPageForgeApp.0354a2e7.js\",\"iXr0W\",\"GlobalSettingsForgeApp.14ac2712.js\",\"ccJug\",\"HomepageFeedForgeApp.718cdfaf.js\",\"irYLY\",\"SpaceSettingsForgeApp.e9becc8b.js\",\"dTsOE\",\"modal.0d95ebdf.js\",\"ldtPf\",\"SpacePageForgeApp.cd7cb0f3.js\",\"6wcNV\",\"CustomContentForgeApp.8090485a.js\",\"i9jMB\",\"BackgroundScriptForgeApp.523e953d.js\",\"aFNXd\",\"PageBannerForgeApp.82072963.js\",\"aSmvL\",\"DefinitionAction.0405394c.js\",\"dPdkf\",\"file.9fecbbb3.js\",\"ekztv\",\"office-building.1f9fed02.js\",\"3zuUe\",\"quote.693704ee.js\",\"63hQz\",\"documents.dbe23a7f.js\",\"kwiXK\",\"ReadingAidsChangeboardingModal.817ddabe.js\",\"cF8dp\",\"changeboardingModalImage.516388c9.svg\",\"avRkh\",\"ReadingAidsPopup.9dca3afe.js\",\"jHYIB\",\"segment-highlight.9f59281f.js\",\"iabhK\",\"preferences.92de3054.js\",\"aTu7U\",\"code.7aff7dd9.js\",\"eHVyt\",\"bullet-list.a692487e.js\",\"4lfDj\",\"edit.b59079ec.js\",\"9QvHa\",\"actual-size.810640aa.js\",\"2w2Fa\",\"child-issues.1773a591.js\",\"6Nh0d\",\"feedback.7e852256.js\",\"5yCCv\",\"CommentEditor.35cdaaf7.js\",\"EfTik\",\"hoverCard.cf8a6de4.js\",\"9tyrK\",\"react-markdown.8ea69fa2.js\",\"6PtxN\",\"cs.4af6da41.js\",\"8RKtn\",\"da.00cc494f.js\",\"fCIoO\",\"de.feb55cf0.js\",\"1geBW\",\"es.2b9a509c.js\",\"5WU5D\",\"et.c12c2abb.js\",\"i1Uow\",\"fi.577f953a.js\",\"3ZuKT\",\"fr.6da7024a.js\",\"5nJlY\",\"hu.3d953190.js\",\"Uq5C2\",\"it.d747a7e7.js\",\"9TzAL\",\"ja.6cac578c.js\",\"oPAjm\",\"ko.e5176471.js\",\"3fvcK\",\"nb.cf4f3e33.js\",\"iMYDs\",\"nl.0646b6ed.js\",\"jPHqC\",\"pl.7e10aa61.js\",\"3saM6\",\"pt_BR.2e845e69.js\",\"4hCdo\",\"pt_PT.3585f16f.js\",\"78gs3\",\"ru.6f4b63fe.js\",\"2XhMA\",\"sk.9b031399.js\",\"f7Egw\",\"sv.567af81d.js\",\"aiZUj\",\"tr.5656666a.js\",\"6rH3p\",\"th.f0261be3.js\",\"lS1VG\",\"uk.fe1da325.js\",\"fFbe4\",\"vi.32dd8df9.js\",\"7JTjB\",\"zh_TW.3a48b1fe.js\",\"dMjyc\",\"zh.37507780.js\",\"cPSQq\",\"renderer.60c09289.js\",\"lb9xb\",\"smart-card.54dcfde5.js\",\"9wbwa\",\"calendar-dark.a0ed3c18.svg\",\"edV1v\",\"calendar-light.caa4677f.svg\",\"5P10P\",\"location-dark.395fc7dc.svg\",\"1jWRt\",\"location-light.9d9cfd0a.svg\",\"fhU7k\",\"esm.50a6c5c3.js\",\"4hOv8\",\"esm.bc27d7ff.js\",\"1phY7\",\"text-style.b3b9d62b.js\",\"iRpFz\",\"expand.08be709f.js\",\"3JJHk\",\"collapse.401834a6.js\",\"9aAXz\",\"outdent.60811ec4.js\",\"3oVYt\",\"indent.dc6fba28.js\",\"c7DhJ\",\"department.6ce9c430.js\",\"do9PF\",\"definition-popup-content.d5c2ac5f.js\",\"ej4rO\",\"definition-popup-content.bc7e2f46.js\",\"hcY7w\",\"SmartsSummaryErrorComponent.cacf4448.js\",\"4C2Hh\",\"AgentProfileCard.2fb1c2fa.js\",\"bxgNi\",\"HelpPanel.59dc6019.js\",\"efZH2\",\"recent-work-client.f965733d.js\",\"4KiYL\",\"image.752f24fb.js\",\"5GUmv\",\"search-error-dark.43e0a164.svg\",\"14R3W\",\"search-error-light.02ef2e6f.svg\",\"atmg2\",\"image.c35a1a92.js\",\"5nvBH\",\"landing-dark.4ee27e71.svg\",\"kv0qb\",\"landing-light.0988f0a2.svg\",\"g5R8w\",\"image.48d8ab55.js\",\"8yV1V\",\"no-results-dark.a00ae47b.svg\",\"3bsGr\",\"no-results-light.5ca83755.svg\",\"8F6ik\",\"result-provider.5c4ddeb9.js\",\"hHoTx\",\"error-image.8fb3088b.js\",\"lUh9w\",\"async-select.6afce3ad.js\",\"fEM7I\",\"static-select-filter.c9a569e7.js\",\"bBtaF\",\"multi-select-filter.11ac1b7a.js\",\"3BloW\",\"image.3b8183f2.js\",\"9RypW\",\"image.5b324d28.js\",\"4alnS\",\"no-results-light.5ca83755.svg\",\"bE2Fu\",\"no-results-dark.a00ae47b.svg\",\"6kNSo\",\"autocorrection-renderer.ae032fb3.js\",\"eQXoP\",\"image.d13a8a6e.js\",\"yzZO6\",\"search-error-light.02ef2e6f.svg\",\"e84X7\",\"search-error-dark.43e0a164.svg\",\"6sXO4\",\"drop-down-links.c7381ca6.js\",\"4Sse2\",\"image.edae005c.js\",\"4KkwT\",\"prequery-empty-screen-light.0988f0a2.svg\",\"eM7lm\",\"prequery-empty-screen-dark.4ee27e71.svg\",\"5kEKD\",\"upsell-modal.bff58bd8.js\",\"kqtzG\",\"compass-bitbucket-upsell-banner.1bbe07cf.png\",\"jjAxo\",\"smart-user-picker.f35128ab.js\",\"8XFC9\",\"ai-answer-onboarding-banner.c3df8363.js\",\"5QGog\",\"search-client.caee183d.js\",\"fiCwF\",\"search-ai.fc0c5e1d.js\",\"900yZ\",\"search-ai.78fb4a6c.js\",\"dXz7U\",\"cs.0fe20447.js\",\"gGEZv\",\"da.5e326861.js\",\"d3blt\",\"de.f2e52cca.js\",\"59Z93\",\"en_GB.f3bb8ea9.js\",\"kotjW\",\"en_ZZ.e3c70604.js\",\"kK6se\",\"es.73277c94.js\",\"5xf60\",\"et.7581eb28.js\",\"9VEIz\",\"fi.f59743b9.js\",\"cjdHS\",\"fr.a54fbcf6.js\",\"Whd6n\",\"hu.c52d8558.js\",\"jkUKZ\",\"is.a0ebfb14.js\",\"9LPlo\",\"it.c21faee5.js\",\"bCZbu\",\"ja.9ad18577.js\",\"jUfGx\",\"ko.97055cec.js\",\"8yxgV\",\"nb.5c9fb324.js\",\"dBE2i\",\"nl.d8ed66b7.js\",\"6FNZU\",\"pl.09a6a923.js\",\"ilWcC\",\"pt_BR.97ee635a.js\",\"edU6Z\",\"pt_PT.94fccdb2.js\",\"atNxX\",\"ro.e8b3e3a3.js\",\"gpgvY\",\"ru.5638ece1.js\",\"3IA7L\",\"sk.9ec26891.js\",\"hpq4P\",\"sv.c619cbc9.js\",\"8WMbP\",\"th.b189e833.js\",\"kffHA\",\"tr.8f9b06ad.js\",\"2zh8u\",\"uk.9b35366e.js\",\"9YoTA\",\"vi.69a13d7c.js\",\"a9qyt\",\"zh.01374c8a.js\",\"04egH\",\"zh_TW.fe919e56.js\",\"1Ojgx\",\"ai-answer-prompt.27b73827.js\",\"eVnxm\",\"trello-body.8137f9fd.js\",\"2exA8\",\"trello-popper.e48ef4ba.js\",\"5LCFM\",\"esm.fbe78c82.js\",\"bvkZd\",\"no-results-dark.a00ae47b.svg\",\"cV42Q\",\"no-results-light.5ca83755.svg\",\"8NLae\",\"CommentEditor.f213ce54.js\",\"k4PhO\",\"global-opt-in-default-image-banner.cf053e66.svg\",\"9X5xA\",\"quickSummaryUpsellBannerLight.edcc3647.svg\",\"iLB51\",\"quickSummaryUpsellBannerDark.e27429f6.svg\",\"cp1n9\",\"TreeBottomCreateButton.ac4d86a7.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.1b8accfe.js\",\"5Ixal\",\"CreateFolderPopoverItemSpotlight.0dc0692c.svg\",\"lzaHa\",\"ContextualCreateContentPopoverMenu.fda67a7f.js\",\"16ht2\",\"CreateFromTemplate.36f5853b.js\",\"hvHZS\",\"TemplatePreview.2b6344f0.js\",\"6JdS4\",\"blogPostIcon.e3cb4562.svg\",\"5fnDv\",\"loadingErrorIcon.3c97c605.svg\",\"bupWa\",\"PopupPreview.5c4938c8.js\",\"3yGMH\",\"displayErrorIcon.3bd706b2.svg\",\"4NgYy\",\"ContextualCreateContentPopoverMenu.2ada1402.js\",\"clpSH\",\"PageTreeQuickActions.59363bb7.js\",\"13PnU\",\"QuickActionsContent.90afbd13.js\",\"6rpul\",\"ArchivedPageBannerV2.548f4ab2.js\",\"dxDVc\",\"UnarchivePagesLoader.342a5885.js\",\"jkoeR\",\"RendererContentStateWithSpotlight.03a0389b.js\",\"djzzD\",\"PageLabelsAutomationDiscovery.446dd93f.js\",\"f7WA2\",\"SlackDiscoveryDialog.cf25e1b1.js\",\"eRzO9\",\"BulkChangePageOwnerDialog.d746b0cd.js\",\"1rMtp\",\"PagePublishAutomationDiscoveryDialog.92b2fc0c.js\",\"jdEwy\",\"JiraLinkAutomationDiscoveryDialog.7b540e10.js\",\"696ho\",\"WhiteBoardPublishDiscoveryDialog.8800a272.js\",\"1NKZf\",\"AutomationDiscoveryHoverPageTitleMessage.b011bcf3.js\",\"6sAbi\",\"ArchivePageAutomationDiscovery.e994fea9.js\",\"11AeH\",\"AutomationDiscoveryHeader.6db01409.svg\",\"2tDVK\",\"MovePageDialog.c0b16470.js\",\"gcXcg\",\"UnarchivePagesLoader.97aebcdb.js\",\"kDklq\",\"UnarchivePagesLoader.1105affa.js\",\"7dkWW\",\"ArchivedPageBannerV2.a096864c.js\",\"3uux1\",\"ArchivePagesLoader.15d7bacc.js\",\"cPaXL\",\"ArchiveUpsellDialog.387ebda7.js\",\"anGwD\",\"BulkArchivePagesLoader.8e769a5a.js\",\"f0OaY\",\"ArchiveRemoteProcessContainer.29d39311.js\",\"hVNnP\",\"UpdateArchivedPageNoteDialog.06a25f6d.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.0d312ae6.js\",\"9YGIy\",\"DeleteNestedPagesAction.87cb62e0.js\",\"iomzR\",\"DeletePageDialog.c1db3e1c.js\",\"k3BGs\",\"DeleteNestedPagesAction.da65be3a.js\",\"adHzf\",\"DeleteNestedPagesAction.af5a528e.js\",\"4JUnA\",\"BulkDeletePagesAction.551c9007.js\",\"5YvMC\",\"BulkChangeOwnerAction.b8e214a7.js\",\"bXkeF\",\"BulkChangeStatusAction.96a399d1.js\",\"leIbB\",\"BulkChangeStatusAction.a389690b.js\",\"1aFR7\",\"NestedChangeOwnerAction.4586146f.js\",\"Pp5sV\",\"NestedConvertPageToLiveDocAction.9804acc9.js\",\"lgZ1d\",\"BulkConvertPageToLiveDocAction.dc529516.js\",\"p4ay7\",\"CopyPageTreeContainer.ccd7ea72.js\",\"i5Fj1\",\"data-classification.109211c0.js\",\"jnk96\",\"DataClassification.6d540039.js\",\"gEi5K\",\"NotFound.95938568.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"bn8Oy\",\"OverviewNotFound.589d9b68.js\",\"4jFyQ\",\"icon-space-overview-empty.106059f9.svg\",\"3b99S\",\"EditorContentClassificationTag.d9726fb7.js\",\"1zPhe\",\"EditorDataClassification.d164af03.js\",\"avzJW\",\"EditorDataClassificationComponent.ac2525c4.js\",\"4Oj5y\",\"ContentTypeClassification.4e6b4f1b.js\",\"iJsKa\",\"ClassificationReadViewPopup.916ee61f.js\",\"cEDfx\",\"DataClassificationHoverButton.229e6e5c.js\",\"9wTW2\",\"EditorClassificationTagWrapper.f24b8d90.js\",\"iLLJH\",\"CommentEditor.cda85758.js\",\"affRy\",\"FullPageEditorComponent.0b55717f.js\",\"5odbj\",\"ClassificationTagButtonError.1b9558b9.js\",\"4Qstt\",\"ClassificationEditModal.928a4a72.js\",\"58UdM\",\"ClassificationEditViewPopup.c3b1a30d.js\",\"5ko8n\",\"MovePageDialog.9687464c.js\",\"f9QHk\",\"TreeMonitor.3caa2a6d.js\",\"TpLgp\",\"Controller.bf15d7aa.js\",\"fnUik\",\"GeneralAccessLevelSelector.0f5e85b2.js\",\"kxRVH\",\"AccessRequestsButton.4cbd2ff1.js\",\"Ohbxv\",\"PublicLinkPermissionsSpotlight.328990b4.svg\",\"gjKgt\",\"PublicLinkButtonSpotlight.9320b1e3.svg\",\"k0hwN\",\"ShareToSlack.0a72a448.js\",\"lVO4z\",\"cs.66d17b1d.js\",\"2FVbf\",\"da.45f5bf76.js\",\"ljo6M\",\"de.87ff8d2a.js\",\"9lT7a\",\"en_GB.3f736bc3.js\",\"cNgJs\",\"en.53674b7a.js\",\"aHeMo\",\"en_ZZ.90d281af.js\",\"8d6ia\",\"es.44f7b6ae.js\",\"jh8UJ\",\"fi.bd46bce1.js\",\"bYwCr\",\"fr.854524fc.js\",\"11NiT\",\"hu.21eb6dc5.js\",\"le8VA\",\"it.111da4a0.js\",\"1beJ2\",\"ja.25f13916.js\",\"1tXCh\",\"ko.c7b3c730.js\",\"jzP8g\",\"nb.6ab8a8d0.js\",\"dJY66\",\"nl.b11fd7f9.js\",\"4foYW\",\"pl.200ddf23.js\",\"j0yc3\",\"pt_BR.3fad7d31.js\",\"RfEmw\",\"ru.64b44490.js\",\"5DOlG\",\"sv.812498a9.js\",\"6rD7n\",\"tr.6280d059.js\",\"1e62a\",\"th.646e04f8.js\",\"eLsCU\",\"uk.87a103d8.js\",\"g9qHs\",\"vi.352e605d.js\",\"2ri5s\",\"zh_TW.40e2425f.js\",\"3k60n\",\"zh.af15c051.js\",\"hxIYN\",\"integration-primer.cead19d9.svg\",\"5oKDR\",\"disabled-alert.0ba0a4e5.svg\",\"dIuhJ\",\"link-filled.19c799b9.js\",\"f9XGo\",\"CoreInvites.6f51b2ec.js\",\"e39BD\",\"SlackTeamsSpotlight.6c8b3cc7.js\",\"fniFO\",\"Ed.971a9eb8.svg\",\"b5Vj8\",\"Katina.a5091468.svg\",\"aNfB2\",\"Myra.bfce28e5.svg\",\"jpChu\",\"Oliver.efa0d68b.svg\",\"3IQHf\",\"slackSpotlight.c7655f37.svg\",\"35VU5\",\"cs.d801dcbc.js\",\"6W6gh\",\"da.bac7ddcf.js\",\"bfTAm\",\"de.c95398fc.js\",\"fP9up\",\"en_GB.98e5ca88.js\",\"hc0i6\",\"en.8117d663.js\",\"15E48\",\"en_ZZ.00ef7c85.js\",\"jLWG0\",\"es.7e41636e.js\",\"9J49E\",\"fi.89090e5d.js\",\"br9SP\",\"fr.2a048ea9.js\",\"5h4sF\",\"hu.c2dc4635.js\",\"1MV5Z\",\"it.05b27b71.js\",\"iV5Fv\",\"ja.7b259d22.js\",\"7R5mJ\",\"ko.203f86ca.js\",\"5XMUp\",\"nb.e44f5efd.js\",\"jaDFz\",\"nl.405ee529.js\",\"LOg5S\",\"pl.23c5179b.js\",\"lnJdQ\",\"pt_BR.805e95d7.js\",\"hqsLl\",\"ru.c980f637.js\",\"j0btO\",\"sv.9635f53d.js\",\"2YEqr\",\"tr.ddf2ab95.js\",\"7zFV7\",\"th.3ecc11fa.js\",\"fZ22O\",\"uk.04a59e12.js\",\"4tleS\",\"vi.cca22a6d.js\",\"bE6tX\",\"zh_TW.af40ed8f.js\",\"esYD7\",\"zh.8eeac7b4.js\",\"7oczk\",\"cs.f94e9acb.js\",\"e2gl6\",\"da.452fc83f.js\",\"9oo3s\",\"de.e603f414.js\",\"fRPrc\",\"en_GB.113ccfd3.js\",\"dC0KT\",\"en.2f60c19a.js\",\"gbKsh\",\"en_ZZ.71260efd.js\",\"1ZyUV\",\"es.30208975.js\",\"6tijD\",\"et.a748dc81.js\",\"6fkVy\",\"fi.6cd6b4f0.js\",\"5nw5x\",\"fr.183ce9c7.js\",\"jK12s\",\"hu.f759293a.js\",\"6lWvL\",\"is.e7fee0c5.js\",\"kk9To\",\"it.4d1316fd.js\",\"lyt83\",\"ja.8bae3143.js\",\"2uvfp\",\"ko.c72b821f.js\",\"4Wx8B\",\"nb.6f591f7c.js\",\"huTg5\",\"nl.19b2af2c.js\",\"fPfEd\",\"pl.d1f6bfb2.js\",\"fTYhL\",\"pt_BR.dc22514f.js\",\"dVHhf\",\"pt_PT.137566ba.js\",\"2SsCI\",\"ro.a2a72a07.js\",\"kVi5E\",\"ru.20b35c16.js\",\"6HoYh\",\"sk.63554299.js\",\"kOAvl\",\"sv.9189f5e0.js\",\"5ErHy\",\"tr.da3f85c6.js\",\"jJzpI\",\"th.32ffc0a2.js\",\"2PvRH\",\"uk.7f0edb44.js\",\"eUGjU\",\"vi.f2681927.js\",\"drbCf\",\"zh_TW.356972f3.js\",\"5dk6T\",\"zh.063dc4ca.js\",\"7pAFt\",\"WarningIllustration.8adc2aae.js\",\"2CfIU\",\"WarningIllustration.ec26752f.png\",\"13QWg\",\"in-trial-feature-gates-banner.0b6ee2bc.js\",\"i3TSs\",\"RestrictionsDialog.83b35bd8.js\",\"85liN\",\"InspectPermissionsDialog.246b5ee2.js\",\"14XOE\",\"InspectPermissionsDialog.0a502ad3.js\",\"69XGw\",\"InspectPermissionsEntryPoint.57c2b610.js\",\"8sFYu\",\"RestrictionsDialog.c0518aa4.js\",\"iO9O1\",\"personal_space.c63f5733.png\",\"2YtNo\",\"ObjectSidebarControl.137f29d8.js\",\"6oPQN\",\"ObjectSidebarControl.runtime.46844c23.js\",\"6oPQN\",\"ObjectSidebarControl.runtime.46844c23.js\",\"aoUod\",\"MoveBlogModal.9e46d653.js\",\"2Qrvo\",\"QuickActionsContent.c2023a41.js\",\"kRtpG\",\"QuickActionsContent.458e5173.js\",\"3D26r\",\"QuickActionsContent.runtime.9a1cc99a.js\",\"3D26r\",\"QuickActionsContent.runtime.9a1cc99a.js\",\"PNyg1\",\"InlineRename.271498ac.js\",\"2irg6\",\"MovePageDialog.225a4751.js\",\"3L1uC\",\"PageTreeErrorComponent.b558e03e.js\",\"dhqJV\",\"FooterCreateButtons.bccae8aa.js\",\"67Pvd\",\"ContentTreeOnboarding.2c9d5ad6.js\",\"e19Zv\",\"LiveDocsIconTile.39a4fef5.js\",\"d1QkY\",\"TreeBottomCreateButton.875df4f9.js\",\"fnoJZ\",\"HomepageIcon.129a4e5b.js\",\"6gau7\",\"DraftLozenge.83230e38.js\",\"5zDuS\",\"NativeCollabComponent.2d426b34.js\",\"hHYS0\",\"ModernizedBreadcrumbsIndentIcon.be02b2bc.js\",\"1TkAG\",\"IndentIcon.798032fb.js\",\"aLenh\",\"LiveDocSpotlightsTour.8c62f954.js\"]"));


//# sourceMappingURL=nativeEditorComponentsPreloader.8e0e35b2.js.map
